// import React, { useEffect, useState, useRef } from 'react';
// import api from '../../services/api';
// import { useNavigate, useParams } from 'react-router-dom';
// import monitoringApi from '../../services/monitoringApi';

// /* ─── Font injection ─────────────────────────────────────────────── */
// if (typeof document !== 'undefined' && !document.getElementById('vd-fonts')) {
//   const link = document.createElement('link');
//   link.id = 'vd-fonts';
//   link.rel = 'stylesheet';
//   link.href =
//     'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=JetBrains+Mono:wght@400;600;700&display=swap';
//   document.head.appendChild(link);
// }

// /* ─── Design tokens ─────────────────────────────────────────────── */
// const T = {
//   ink:      '#0F172A',
//   ink2:     '#1E293B',
//   slate:    '#64748B',
//   muted:    '#94A3B8',
//   faint:    '#CBD5E1',
//   bg:       '#F5F6FA',
//   surface:  '#FFFFFF',
//   surface2: '#F8FAFC',
//   bdr:      '#E2E8F0',
//   red:    '#DC2626', redBg:  '#FEF2F2', redBdr:  '#FECACA',
//   amb:    '#B45309', ambBg:  '#FFFBEB', ambBdr:  '#FDE68A',
//   grn:    '#15803D', grnBg:  '#F0FDF4', grnBdr:  '#BBF7D0',
//   blue:   '#3B82F6', blueBg: '#EFF6FF', blueBdr: '#BFDBFE',
//   indigo: '#1E40AF',
// };

// const mono = "'JetBrains Mono', monospace";
// const sans = "'Inter', system-ui, sans-serif";

// /* ─── Types ──────────────────────────────────────────────────────── */
// interface Vendor {
//   id: string;
//   name: string;
//   domain: string;
//   score: number;
//   riskLevel: string;
//   lastScan: string;
//   createdAt: string;
//   owner?: string;
//   businessOwner?: string;
//   onboardedAt?: string;
//   category?: string;
//   vendorId?: string;
//   status?: string;
// }

// interface Scan {
//   id: string;
//   scan_id: string;
//   domain: string;
//   overall_score: number;
//   risk_level: string;
//   created_at: string;
//   completed_at: string;
//   scan_type?: string;
// }

// interface ScanComparison {
//   has_comparison: boolean;
//   scan_count?: number;
//   latest_scan: { id: string; score: number; risk_level: string; date: string };
//   previous_scan: { id: string; score: number; risk_level: string; date: string };
//   score_change: number;
//   improved: Array<{ indicator_name: string; category: string; old_impact: number; new_impact: number; change: number; severity: string }>;
//   declined: Array<{ indicator_name: string; category: string; old_impact: number; new_impact: number; change: number; severity: string }>;
//   new_issues: Array<{ indicator_name: string; category: string; impact: number; severity: string; description: string }>;
//   resolved: Array<{ indicator_name: string; category: string; old_impact: number; severity: string }>;
//   summary: { improved_count: number; declined_count: number; new_count: number; resolved_count: number; total_change: number };
//   peers?: Array<{ name: string; score: number }>;
// }

// interface VendorSchedule {
//   id?: string;
//   vendor_id?: string;
//   frequency?: string;
//   day_of_week?: number | null;
//   day_of_month?: number | null;
//   time?: string;
//   is_active?: number;
//   last_run?: string | null;
//   next_run?: string | null;
//   scan_type?: string;
//   auto_notify?: boolean;
//   assigned_to?: string;
//   using_global?: boolean;
// }

// interface DriftSettings {
//   score_threshold: number;
//   risk_level_drift: number;
//   compliance_drop_percentage: number;
//   is_active: number;
// }

// interface Subdomain {
//   subdomain: string;
//   auto_environment: string;
//   environment: string;
//   is_override: boolean;
//   override_reason: string | null;
//   findings_count: number;
// }

// interface SubdomainCounts {
//   production: number;
//   non_production: number;
//   internal: number;
//   unknown: number;
// }

// /* ─── Helpers ────────────────────────────────────────────────────── */
// const scoreColor = (s: number) =>
//   s >= 80 ? T.grn : s >= 60 ? T.amb : s >= 40 ? '#C2410C' : T.red;

// const getRiskCfg = (level: string) => {
//   const l = (level || '').toLowerCase();
//   if (l === 'high' || l === 'critical')
//     return { bg: T.redBg, bdr: T.redBdr, text: T.red, label: level };
//   if (l === 'medium')
//     return { bg: T.ambBg, bdr: T.ambBdr, text: T.amb, label: level };
//   if (l === 'low')
//     return { bg: T.grnBg, bdr: T.grnBdr, text: T.grn, label: level };
//   return { bg: T.surface2, bdr: T.bdr, text: T.slate, label: level || 'Unknown' };
// };

// const RiskBadge = ({ level }: { level: string }) => {
//   const cfg = getRiskCfg(level);
//   return (
//     <span style={{
//       display: 'inline-flex', alignItems: 'center', gap: 4,
//       padding: '3px 9px', borderRadius: 5,
//       background: cfg.bg, border: `1px solid ${cfg.bdr}`,
//       fontSize: 11, fontWeight: 600, color: cfg.text,
//     }}>{cfg.label}</span>
//   );
// };

// const TrendPill = ({ delta }: { delta: number }) => {
//   if (delta > 0) return (
//     <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, padding: '2px 8px', borderRadius: 99, fontSize: 10, fontWeight: 600, border: `1px solid ${T.grn}`, color: T.grn, background: T.grnBg }}>
//       ▲ +{delta}
//     </span>
//   );
//   if (delta < 0) return (
//     <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, padding: '2px 8px', borderRadius: 99, fontSize: 10, fontWeight: 600, border: `1px solid ${T.red}`, color: T.red, background: T.redBg }}>
//       ▼ {delta}
//     </span>
//   );
//   return (
//     <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, padding: '2px 8px', borderRadius: 99, fontSize: 10, fontWeight: 600, border: `1px solid ${T.bdr}`, color: T.muted, background: T.surface2 }}>
//       —
//     </span>
//   );
// };

// const SevChip = ({ sev }: { sev: string }) => {
//   const colors: Record<string, [string, string, string]> = {
//     Critical: [T.redBg,  T.redBdr,  T.red],
//     High:     [T.ambBg,  T.ambBdr,  T.amb],
//     Medium:   ['#FFF7ED','#FED7AA','#C2410C'],
//     Low:      [T.blueBg, T.blueBdr, T.blue],
//   };
//   const [bg, bdr, text] = colors[sev] || [T.surface2, T.bdr, T.slate];
//   return (
//     <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, padding: '1px 7px', borderRadius: 3, background: bg, border: `1px solid ${bdr}`, fontSize: 10, fontWeight: 700, color: text, fontFamily: mono, letterSpacing: '.05em' }}>
//       {sev.toUpperCase()}
//     </span>
//   );
// };

// /* ─── ChartJS Loader ─────────────────────────────────────────────── */
// const useChartJS = () => {
//   const [ready, setReady] = useState(!!(window as any).Chart);
//   useEffect(() => {
//     if ((window as any).Chart) { setReady(true); return; }
//     const s = document.createElement('script');
//     s.src = 'https://cdnjs.cloudflare.com/ajax/libs/Chart.js/4.4.1/chart.umd.js';
//     s.onload = () => setReady(true);
//     document.head.appendChild(s);
//   }, []);
//   return ready;
// };

// /* ─── TrendLineChart ─────────────────────────────────────────────── */
// const TrendLineChart = ({ scores, riskColor }: { scores: { date: string; score: number }[]; riskColor: string }) => {
//   const canvasRef = useRef<HTMLCanvasElement>(null);
//   const chartRef  = useRef<any>(null);
//   const chartReady = useChartJS();

//   useEffect(() => {
//     if (!chartReady) return;
//     const canvas = canvasRef.current;
//     if (!canvas) return;
//     const Chart = (window as any).Chart;
//     if (chartRef.current) chartRef.current.destroy();
//     const labels = scores.map(s => new Date(s.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }));
//     const data   = scores.map(s => s.score);
//     chartRef.current = new Chart(canvas, {
//       type: 'line',
//       data: {
//         labels,
//         datasets: [{
//           data,
//           borderColor: riskColor,
//           backgroundColor: `${riskColor}12`,
//           borderWidth: 2,
//           pointRadius: 3,
//           pointBackgroundColor: riskColor,
//           fill: true,
//           tension: 0.4,
//         }],
//       },
//       options: {
//         responsive: true, maintainAspectRatio: false,
//         plugins: { legend: { display: false }, tooltip: { mode: 'index', intersect: false } },
//         scales: {
//           x: { ticks: { font: { size: 9 }, color: T.muted }, grid: { display: false } },
//           y: { min: 0, max: 100, ticks: { font: { size: 9 }, color: T.muted, stepSize: 25 }, grid: { color: '#F1F5F9' } },
//         },
//       },
//     });
//     return () => chartRef.current?.destroy();
//   }, [chartReady, scores, riskColor]);

//   return (
//     <div style={{ flex: 1, position: 'relative', height: 100 }}>
//       <canvas ref={canvasRef} role="img" aria-label="Risk score trend over time" />
//     </div>
//   );
// };

// /* ─── ComparisonBarChart ─────────────────────────────────────────── */
// const ComparisonBarChart = ({ current, peers }: {
//   current: { name: string; score: number };
//   peers: Array<{ name: string; score: number }>;
// }) => {
//   const all = [current, ...peers];
//   const maxScore = Math.max(...all.map(p => p.score), 100);
//   const avgScore = Math.round(all.reduce((s, p) => s + p.score, 0) / all.length);
//   const barColors = [T.red, T.amb, T.amb, T.red, T.red, T.grn];

//   return (
//     <div>
//       <div style={{ display: 'flex', alignItems: 'flex-end', gap: 4, padding: '0 4px', height: 120 }}>
//         {all.map((p, i) => {
//           const isMain = i === 0;
//           const color = isMain ? scoreColor(p.score) : barColors[i] || T.slate;
//           const heightPct = Math.round((p.score / maxScore) * 100);
//           return (
//             <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5, flex: 1 }}>
//               <div style={{ fontSize: 12, fontWeight: 700, color, lineHeight: 1 }}>{p.score}</div>
//               <div style={{ width: '100%', background: T.surface2, borderRadius: '4px 4px 0 0', height: 80, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', overflow: 'hidden', border: isMain ? `2px solid ${color}` : 'none' }}>
//                 <div style={{ height: `${heightPct}%`, background: color, borderRadius: '3px 3px 0 0', minHeight: 4 }} />
//               </div>
//               <div style={{ fontSize: 9, color: T.slate, textAlign: 'center', maxWidth: 70, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: isMain ? 700 : 400 }}>{p.name}</div>
//             </div>
//           );
//         })}
//       </div>
//       <div style={{ fontSize: 10, color: T.muted, textAlign: 'right', marginTop: 6 }}>
//         Industry Avg: <strong style={{ color: T.ink }}>{avgScore}</strong>
//       </div>
//     </div>
//   );
// };

// /* ─── Shared card style ──────────────────────────────────────────── */
// const card: React.CSSProperties = {
//   background: T.surface, border: `1px solid ${T.bdr}`, borderRadius: 8, padding: 16,
// };
// const cardLabel: React.CSSProperties = {
//   fontSize: 9, fontWeight: 700, color: T.muted, letterSpacing: '.09em',
//   textTransform: 'uppercase', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 5,
// };
// const sectionHdr: React.CSSProperties = {
//   display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10,
// };
// const sectionTitle: React.CSSProperties = {
//   fontSize: 12, fontWeight: 700, color: T.ink,
// };
// const th: React.CSSProperties = {
//   padding: '8px 12px', textAlign: 'left', fontSize: 9, fontWeight: 700,
//   letterSpacing: '.08em', color: T.muted, textTransform: 'uppercase',
//   background: T.surface2, borderBottom: `1px solid ${T.bdr}`,
// };
// const td: React.CSSProperties = {
//   padding: '9px 12px', fontSize: 12, color: T.ink, borderBottom: `1px solid ${T.surface2}`, verticalAlign: 'middle',
// };
// const topBtn = (primary = false): React.CSSProperties => ({
//   display: 'flex', alignItems: 'center', gap: 6,
//   padding: '7px 14px', borderRadius: 5, fontSize: 12, fontWeight: 600,
//   cursor: 'pointer', fontFamily: sans, border: primary ? 'none' : `1px solid ${T.bdr}`,
//   background: primary ? T.ink : T.surface, color: primary ? '#fff' : T.ink,
// });
// const linkBtn: React.CSSProperties = {
//   fontSize: 11, color: T.blue, fontWeight: 600, cursor: 'pointer', background: 'none', border: 'none', fontFamily: sans,
// };

// /* ─── Dialog ─────────────────────────────────────────────────────── */
// const Dialog = ({ open, onClose, title, children, onSave, saving }: {
//   open: boolean; onClose: () => void; title: string;
//   children: React.ReactNode; onSave: () => void; saving: boolean;
// }) => {
//   if (!open) return null;
//   return (
//     <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999 }}>
//       <div style={{ background: T.surface, border: `1px solid ${T.bdr}`, borderRadius: 10, width: 480, maxWidth: '96vw', boxShadow: '0 8px 32px rgba(0,0,0,.12)' }}>
//         <div style={{ padding: '16px 20px', borderBottom: `1px solid ${T.bdr}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//           <span style={{ fontSize: 14, fontWeight: 700, color: T.ink }}>{title}</span>
//           <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 20, color: T.muted, lineHeight: 1 }}>×</button>
//         </div>
//         <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: 14 }}>{children}</div>
//         <div style={{ padding: '14px 20px', borderTop: `1px solid ${T.bdr}`, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
//           <button onClick={onClose} style={{ ...topBtn(false), padding: '6px 16px' }}>Cancel</button>
//           <button onClick={onSave} disabled={saving} style={{ ...topBtn(true), padding: '6px 16px', opacity: saving ? .6 : 1 }}>
//             {saving ? 'Saving…' : 'Save'}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// const FieldLabel = ({ children }: { children: React.ReactNode }) => (
//   <label style={{ fontSize: 11, fontWeight: 600, color: T.slate, letterSpacing: '.05em', marginBottom: 4, display: 'block' }}>{children}</label>
// );
// const Input = (props: React.InputHTMLAttributes<HTMLInputElement>) => (
//   <input {...props} style={{ width: '100%', border: `1px solid ${T.bdr}`, borderRadius: 5, padding: '7px 10px', fontSize: 12, color: T.ink, background: T.surface, outline: 'none', fontFamily: sans, ...props.style }} />
// );
// const SelectEl = (props: React.SelectHTMLAttributes<HTMLSelectElement> & { children: React.ReactNode }) => (
//   <select {...props} style={{ width: '100%', border: `1px solid ${T.bdr}`, borderRadius: 5, padding: '7px 10px', fontSize: 12, color: T.slate, background: T.surface, outline: 'none', fontFamily: sans, cursor: 'pointer', ...props.style }}>
//     {props.children}
//   </select>
// );

// /* ─── SchedItem ──────────────────────────────────────────────────── */
// const SchedItem = ({ icon, label, value }: { icon: string; label: string; value: string }) => (
//   <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', background: T.surface2, borderRadius: 6 }}>
//     <div style={{ width: 32, height: 32, borderRadius: 6, background: T.blueBg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: 15, color: T.blue }}>{icon}</div>
//     <div>
//       <div style={{ fontSize: 10, color: T.muted, marginBottom: 2 }}>{label}</div>
//       <div style={{ fontSize: 12, fontWeight: 600, color: T.ink }}>{value}</div>
//     </div>
//   </div>
// );

// /* ─── ComparisonTable ────────────────────────────────────────────── */
// const CompTable = ({ rows, headerBg, cols }: {
//   rows: any[];
//   headerBg: string;
//   cols: { label: string; render: (row: any) => React.ReactNode }[];
// }) => (
//   <div style={{ border: `1px solid ${T.bdr}`, borderRadius: 6, overflow: 'hidden', marginBottom: 16 }}>
//     <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//       <thead>
//         <tr style={{ background: headerBg }}>
//           {cols.map(c => <th key={c.label} style={th}>{c.label}</th>)}
//         </tr>
//       </thead>
//       <tbody>
//         {rows.map((row, i) => (
//           <tr key={i} style={{ borderBottom: i < rows.length - 1 ? `1px solid ${T.bdr}` : 'none' }}>
//             {cols.map(c => <td key={c.label} style={td}>{c.render(row)}</td>)}
//           </tr>
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// /* ─── Subdomain Override Modal ───────────────────────────────────── */
// const SubdomainOverrideModal = ({ open, onClose, subdomain, currentEnv, onSave, saving }: {
//   open: boolean;
//   onClose: () => void;
//   subdomain: Subdomain | null;
//   currentEnv: string;
//   onSave: (environment: string, reason: string) => void;
//   saving: boolean;
// }) => {
//   const [selectedEnv, setSelectedEnv] = useState(currentEnv);
//   const [reason, setReason] = useState('');

//   useEffect(() => {
//     if (open) {
//       setSelectedEnv(currentEnv);
//       setReason(subdomain?.override_reason || '');
//     }
//   }, [open, currentEnv, subdomain]);

//   if (!open || !subdomain) return null;

//   const environments = [
//     { value: 'production',     label: '🔴 Production' },
//     { value: 'non_production', label: '🟡 Non-Production' },
//     { value: 'internal',       label: '🟠 Internal' },
//     { value: 'unknown',        label: '⚪ Unknown' },
//   ];

//   return (
//     <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
//       <div style={{ background: T.surface, border: `1px solid ${T.bdr}`, borderRadius: 10, width: 450, maxWidth: '96vw', boxShadow: '0 8px 32px rgba(0,0,0,.12)' }}>
//         <div style={{ padding: '16px 20px', borderBottom: `1px solid ${T.bdr}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//           <span style={{ fontSize: 14, fontWeight: 700, color: T.ink }}>Override Subdomain: {subdomain.subdomain}</span>
//           <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 20, color: T.muted, lineHeight: 1 }}>×</button>
//         </div>
//         <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: 14 }}>
//           <div>
//             <FieldLabel>Current Classification</FieldLabel>
//             <div style={{ padding: '8px 12px', background: T.surface2, borderRadius: 5, fontSize: 12 }}>
//               Auto-detected: <strong>{subdomain.auto_environment}</strong>
//               {subdomain.is_override && <span style={{ marginLeft: 8, color: T.blue }}>✏️ Overridden</span>}
//             </div>
//           </div>
//           <div>
//             <FieldLabel>Override Environment</FieldLabel>
//             <select
//               value={selectedEnv}
//               onChange={e => setSelectedEnv(e.target.value)}
//               style={{ width: '100%', border: `1px solid ${T.bdr}`, borderRadius: 5, padding: '8px 12px', fontSize: 12, background: T.surface, fontFamily: sans }}
//             >
//               {environments.map(env => (
//                 <option key={env.value} value={env.value}>{env.label}</option>
//               ))}
//             </select>
//           </div>
//           <div>
//             <FieldLabel>Reason (Optional)</FieldLabel>
//             <textarea
//               value={reason}
//               onChange={e => setReason(e.target.value)}
//               placeholder="Why are you overriding this classification?"
//               style={{ width: '100%', border: `1px solid ${T.bdr}`, borderRadius: 5, padding: '8px 12px', fontSize: 12, fontFamily: sans, minHeight: 80, resize: 'vertical' }}
//             />
//           </div>
//         </div>
//         <div style={{ padding: '14px 20px', borderTop: `1px solid ${T.bdr}`, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
//           <button onClick={onClose} style={{ ...topBtn(false), padding: '6px 16px' }}>Cancel</button>
//           <button onClick={() => onSave(selectedEnv, reason)} disabled={saving} style={{ ...topBtn(true), padding: '6px 16px', opacity: saving ? .6 : 1 }}>
//             {saving ? 'Saving…' : 'Save Override'}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// /* ─── Main Component ─────────────────────────────────────────────── */
// export default function VendorDetails() {
//   const { vendorId } = useParams();
//   const navigate     = useNavigate();

//   const [vendor,             setVendor]             = useState<Vendor | null>(null);
//   const [scans,              setScans]              = useState<Scan[]>([]);
//   const [loading,            setLoading]            = useState(true);
//   const [loadingComparison,  setLoadingComparison]  = useState(false);
//   const [error,              setError]              = useState<string | null>(null);
//   const [comparison,         setComparison]         = useState<ScanComparison | null>(null);
//   const [activeTab,          setActiveTab]          = useState<'overview' | 'profile' | 'assessments' | 'documents' | 'contacts' | 'contracts' | 'issues' | 'history'>('overview');
//   const [vendorSchedule,     setVendorSchedule]     = useState<VendorSchedule | null>(null);
//   const [driftSettings,      setDriftSettings]      = useState<DriftSettings | null>(null);
//   const [scheduleDialogOpen, setScheduleDialogOpen] = useState(false);
//   const [driftDialogOpen,    setDriftDialogOpen]    = useState(false);
//   const [editingSchedule,    setEditingSchedule]    = useState({ frequency: 'monthly', day_of_week: 1, day_of_month: 1, time: '09:00', is_active: 1 });
//   const [editingDrift,       setEditingDrift]       = useState({ score_threshold: 70, risk_level_drift: 2, compliance_drop_percentage: 15, is_active: 1 });
//   const [saving,             setSaving]             = useState(false);
//   const [compFilter,         setCompFilter]         = useState('Risk Score');

//   const [subdomains,      setSubdomains]      = useState<Subdomain[]>([]);
//   const [subdomainCounts, setSubdomainCounts] = useState<SubdomainCounts>({ production: 0, non_production: 0, internal: 0, unknown: 0 });
//   const [loadingSubdomains, setLoadingSubdomains] = useState(false);
//   const [subdomainTab,    setSubdomainTab]    = useState<'all' | 'production' | 'non_production' | 'internal'>('all');
//   const [editingSubdomain,  setEditingSubdomain]  = useState<Subdomain | null>(null);
//   const [showOverrideModal, setShowOverrideModal] = useState(false);
//   const [savingOverride,    setSavingOverride]    = useState(false);

//   useEffect(() => {
//     if (vendorId) {
//       fetchVendorDetails();
//       fetchScanComparison();
//       fetchVendorMonitoring();
//     }
//   }, [vendorId]);

//   useEffect(() => {
//     if (vendor?.domain) fetchSubdomains();
//   }, [vendor?.domain]);

//   const fetchVendorDetails = async () => {
//     try {
//       const { data } = await api.get(`/v1/vendors/${vendorId}`);
//       setVendor(data);
//       await fetchScansForDomain(data.domain);
//     } catch {
//       setError('Failed to load vendor details');
//       setLoading(false);
//     }
//   };

//   const fetchScansForDomain = async (domain: string) => {
//     try {
//       const r = await api.get(`/v1/scans/by-domain/${domain}`);
//       let s: Scan[] = r.data.scans && Array.isArray(r.data.scans) ? r.data.scans : Array.isArray(r.data) ? r.data : [];
//       s.sort((a, b) => new Date(b.completed_at || b.created_at).getTime() - new Date(a.completed_at || a.created_at).getTime());
//       setScans(s);
//     } catch {
//       try {
//         const all = await api.get('/v1/scans');
//         const filtered = (all.data.scans || []).filter((s: Scan) => s.domain === domain);
//         filtered.sort((a: Scan, b: Scan) => new Date(b.completed_at || b.created_at).getTime() - new Date(a.completed_at || a.created_at).getTime());
//         setScans(filtered);
//       } catch {/* silent */}
//     } finally { setLoading(false); }
//   };

//   const fetchScanComparison = async () => {
//     if (!vendorId) return;
//     setLoadingComparison(true);
//     try {
//       const { data } = await api.get(`/v1/vendors/${vendorId}/scan-comparison`);
//       setComparison(data);
//     } catch { /* silent */ }
//     finally { setLoadingComparison(false); }
//   };

//   const fetchVendorMonitoring = async () => {
//     if (!vendorId) return;
//     try {
//       const [sched, drift] = await Promise.all([
//         monitoringApi.getVendorSchedule(vendorId),
//         monitoringApi.getDriftSettings(vendorId),
//       ]);
//       setVendorSchedule(sched.data);
//       setDriftSettings(drift.data);
//       if (sched.data && !sched.data.using_global) {
//         setEditingSchedule({
//           frequency:    sched.data.frequency    || 'monthly',
//           day_of_week:  sched.data.day_of_week  || 1,
//           day_of_month: sched.data.day_of_month || 1,
//           time:         sched.data.time         || '09:00',
//           is_active:    sched.data.is_active     || 1,
//         });
//       }
//       if (drift.data) {
//         setEditingDrift({
//           score_threshold:            drift.data.score_threshold            || 70,
//           risk_level_drift:           drift.data.risk_level_drift           || 2,
//           compliance_drop_percentage: drift.data.compliance_drop_percentage || 15,
//           is_active:                  drift.data.is_active                  || 1,
//         });
//       }
//     } catch { /* silent */ }
//   };

//   const fetchSubdomains = async () => {
//     if (!vendor?.domain) return;
//     setLoadingSubdomains(true);
//     try {
//       const scansRes = await api.get(`/v1/scans/by-domain/${vendor.domain}`);
//       const scansList = scansRes.data.scans || [];
//       if (scansList.length > 0) {
//         const latestScanId = scansList[0].scan_id || scansList[0].id;
//         const response = await api.get(`/v1/vendors/subdomains/${latestScanId}`);
//         setSubdomains(response.data.subdomains || []);
//         setSubdomainCounts(response.data.counts || { production: 0, non_production: 0, internal: 0, unknown: 0 });
//       }
//     } catch (err) {
//       console.error('Failed to fetch subdomains:', err);
//     } finally {
//       setLoadingSubdomains(false);
//     }
//   };

//   const handleSaveOverride = async (environment: string, reason: string) => {
//     if (!editingSubdomain || !vendor?.domain) return;
//     setSavingOverride(true);
//     try {
//       const scansRes = await api.get(`/v1/scans/by-domain/${vendor.domain}`);
//       const scansList = scansRes.data.scans || [];
//       if (scansList.length === 0) return;
//       const latestScanId = scansList[0].scan_id || scansList[0].id;
//       await api.post('/v1/vendors/subdomain/override', {
//         scan_id: latestScanId, subdomain: editingSubdomain.subdomain,
//         environment, reason: reason || null,
//       });
//       await fetchSubdomains();
//       setShowOverrideModal(false);
//       setEditingSubdomain(null);
//     } catch (err) {
//       console.error('Failed to save override:', err);
//       window.alert('Failed to save override. Please try again.');
//     } finally { setSavingOverride(false); }
//   };

//   const handleRevertOverride = async (subdomain: Subdomain) => {
//     if (!window.confirm(`Revert "${subdomain.subdomain}" to auto-classification?`)) return;
//     try {
//       const scansRes = await api.get(`/v1/scans/by-domain/${vendor?.domain}`);
//       const scansList = scansRes.data.scans || [];
//       if (scansList.length === 0) return;
//       const latestScanId = scansList[0].scan_id || scansList[0].id;
//       await api.delete(`/v1/vendors/subdomain/override?scan_id=${latestScanId}&subdomain=${subdomain.subdomain}`);
//       await fetchSubdomains();
//     } catch (err) {
//       console.error('Failed to revert override:', err);
//       window.alert('Failed to revert override. Please try again.');
//     }
//   };

//   const handleSaveSchedule = async () => {
//     if (!vendorId) return;
//     setSaving(true);
//     try {
//       await monitoringApi.createVendorSchedule({ vendor_id: vendorId, ...editingSchedule });
//       setScheduleDialogOpen(false);
//       fetchVendorMonitoring();
//     } catch { /* silent */ }
//     finally { setSaving(false); }
//   };

//   const handleSaveDrift = async () => {
//     if (!vendorId) return;
//     setSaving(true);
//     try {
//       await monitoringApi.updateDriftSettings(vendorId, editingDrift);
//       setDriftDialogOpen(false);
//       fetchVendorMonitoring();
//     } catch { /* silent */ }
//     finally { setSaving(false); }
//   };

//   const handleNewScan  = () => navigate('/scans/new', { state: { company_name: vendor?.name, domain: vendor?.domain } });
//   const handleViewScan = (scanId: string) => navigate(`/scans/${scanId}/results`);

//   const fmtDate = (raw: string) => {
//     const d = new Date(raw);
//     return {
//       date: d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
//       time: d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }),
//     };
//   };
//   const fmtShort = (raw?: string) =>
//     raw ? new Date(raw).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—';

//   const getEnvironmentBadge = (environment: string, isOverride = false) => {
//     const config: Record<string, { icon: string; color: string; bg: string; label: string }> = {
//       production:     { icon: '🔴', color: '#DC2626', bg: '#FEF2F2', label: 'Production' },
//       non_production: { icon: '🟡', color: '#D97706', bg: '#FFFBEB', label: 'Non-Production' },
//       internal:       { icon: '🟠', color: '#EA580C', bg: '#FFF7ED', label: 'Internal' },
//       unknown:        { icon: '⚪', color: '#6B7280', bg: '#F3F4F6', label: 'Unknown' },
//     };
//     const { icon, color, bg, label } = config[environment] || config.unknown;
//     return (
//       <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '2px 8px', borderRadius: 4, background: bg, border: `1px solid ${color}20`, fontSize: 11, fontWeight: 500, color }}>
//         {icon} {label}{isOverride && <span style={{ fontSize: 9 }}>✏️</span>}
//       </span>
//     );
//   };

//   /* ── Derived ──────────────────────────────────────────────────── */
//   const latestScan  = scans[0];
//   const prevScan    = scans[1];
//   const scoreTrend  = prevScan ? (latestScan?.overall_score ?? 0) - (prevScan?.overall_score ?? 0) : 0;
//   const avgScore    = scans.length ? Math.round(scans.reduce((a, s) => a + (s.overall_score || 0), 0) / scans.length) : 0;
//   const bestScore   = scans.length ? Math.max(...scans.map(s => s.overall_score || 0)) : 0;
//   const lowestScore = scans.length ? Math.min(...scans.map(s => s.overall_score || 0)) : 0;

//   const firstScanDate = scans.length
//     ? scans.reduce((oldest, s) => new Date(s.completed_at || s.created_at) < new Date(oldest.completed_at || oldest.created_at) ? s : oldest).completed_at || scans[scans.length - 1].created_at
//     : vendor?.createdAt;

//   const monitoredSince  = firstScanDate || vendor?.createdAt;
//   const monitoredYears  = monitoredSince ? Math.floor((Date.now() - new Date(monitoredSince).getTime()) / (1000*60*60*24*365)) : 0;
//   const monitoredMonths = monitoredSince ? Math.floor((Date.now() - new Date(monitoredSince).getTime()) / (1000*60*60*24*30)) % 12 : 0;
//   const riskColor       = scoreColor(vendor?.score ?? 0);
//   const trendScores     = [...scans].reverse().slice(-6).map(s => ({ date: s.completed_at || s.created_at, score: s.overall_score }));
//   const peers           = comparison?.peers || [{ name: 'Peer A', score: 82 }, { name: 'Peer B', score: 54 }, { name: 'Peer C', score: 45 }, { name: 'Peer D', score: 32 }];
//   const weekDays        = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'];

//   const getFilteredSubdomains = () => {
//     switch (subdomainTab) {
//       case 'production':     return subdomains.filter(s => s.environment === 'production');
//       case 'non_production': return subdomains.filter(s => s.environment === 'non_production');
//       case 'internal':       return subdomains.filter(s => s.environment === 'internal');
//       default:               return subdomains;
//     }
//   };

//   /* ── Loading / Error ──────────────────────────────────────────── */
//   if (loading) return (
//     <div style={{ fontFamily: sans, background: T.bg, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 12 }}>
//       <style>{`@keyframes slide{from{transform:translateX(-40px)}to{transform:translateX(80px)}}`}</style>
//       <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={T.blue} strokeWidth="1.5">
//         <path d="M10 2L3 5v5c0 4.1 3 7.9 7 9 4-1.1 7-4.9 7-9V5L10 2z"/>
//         <path d="M7 12l2 2 5-5" strokeLinecap="round" strokeLinejoin="round"/>
//       </svg>
//       <span style={{ fontFamily: mono, fontSize: 11, color: T.slate, letterSpacing: '.12em' }}>LOADING VENDOR…</span>
//       <div style={{ width: 160, height: 2, background: T.bdr, borderRadius: 2, overflow: 'hidden' }}>
//         <div style={{ width: '60%', height: 2, background: T.blue, borderRadius: 2, animation: 'slide 1.2s ease-in-out infinite alternate' }} />
//       </div>
//     </div>
//   );

//   if (error || !vendor) return (
//     <div style={{ fontFamily: sans, background: T.bg, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//       <div style={{ textAlign: 'center', maxWidth: 360 }}>
//         <div style={{ fontSize: 13, color: T.red, marginBottom: 12, padding: '10px 16px', background: T.redBg, border: `1px solid ${T.redBdr}`, borderRadius: 6 }}>
//           {error || 'Vendor not found.'}
//         </div>
//         <button onClick={() => navigate('/vendors')} style={topBtn(true)}>← Back to Vendors</button>
//       </div>
//     </div>
//   );

//   const initials = vendor.name.split(' ').map((w: string) => w[0]).slice(0, 2).join('').toUpperCase();

//   return (
//     <div style={{ fontFamily: sans, background: T.bg, minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>

//       {/* Subdomain Override Modal */}
//       <SubdomainOverrideModal
//         open={showOverrideModal}
//         onClose={() => { setShowOverrideModal(false); setEditingSubdomain(null); }}
//         subdomain={editingSubdomain}
//         currentEnv={editingSubdomain?.environment || 'unknown'}
//         onSave={handleSaveOverride}
//         saving={savingOverride}
//       />

//       {/* ── Dialogs ──────────────────────────────────────────────── */}
//       <Dialog open={scheduleDialogOpen} onClose={() => setScheduleDialogOpen(false)} title="Configure Scan Schedule" onSave={handleSaveSchedule} saving={saving}>
//         <div><FieldLabel>Frequency</FieldLabel>
//           <SelectEl value={editingSchedule.frequency} onChange={e => setEditingSchedule(p => ({ ...p, frequency: e.target.value }))}>
//             <option value="weekly">Weekly</option>
//             <option value="monthly">Monthly</option>
//             <option value="quarterly">Quarterly</option>
//           </SelectEl>
//         </div>
//         {editingSchedule.frequency === 'weekly' && (
//           <div><FieldLabel>Day of Week</FieldLabel>
//             <SelectEl value={editingSchedule.day_of_week} onChange={e => setEditingSchedule(p => ({ ...p, day_of_week: +e.target.value }))}>
//               {weekDays.map((d, i) => <option key={i} value={i}>{d}</option>)}
//             </SelectEl>
//           </div>
//         )}
//         {editingSchedule.frequency === 'monthly' && (
//           <div><FieldLabel>Day of Month</FieldLabel>
//             <SelectEl value={editingSchedule.day_of_month} onChange={e => setEditingSchedule(p => ({ ...p, day_of_month: +e.target.value }))}>
//               {[...Array(28)].map((_, i) => <option key={i+1} value={i+1}>{i+1}</option>)}
//             </SelectEl>
//           </div>
//         )}
//         <div><FieldLabel>Time (24h)</FieldLabel>
//           <Input type="time" value={editingSchedule.time} onChange={e => setEditingSchedule(p => ({ ...p, time: e.target.value }))} />
//         </div>
//         <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, cursor: 'pointer' }}>
//           <input type="checkbox" checked={editingSchedule.is_active === 1} onChange={e => setEditingSchedule(p => ({ ...p, is_active: e.target.checked ? 1 : 0 }))} />
//           Active
//         </label>
//       </Dialog>

//       <Dialog open={driftDialogOpen} onClose={() => setDriftDialogOpen(false)} title="Configure Drift Detection" onSave={handleSaveDrift} saving={saving}>
//         <div><FieldLabel>Score Threshold (0–100)</FieldLabel>
//           <Input type="number" value={editingDrift.score_threshold} onChange={e => setEditingDrift(p => ({ ...p, score_threshold: +e.target.value }))} />
//           <div style={{ fontSize: 10, color: T.muted, marginTop: 3 }}>Alert when score drops below this value</div>
//         </div>
//         <div><FieldLabel>Risk Level Drift</FieldLabel>
//           <Input type="number" value={editingDrift.risk_level_drift} onChange={e => setEditingDrift(p => ({ ...p, risk_level_drift: +e.target.value }))} />
//           <div style={{ fontSize: 10, color: T.muted, marginTop: 3 }}>Alert when risk level increases by X levels</div>
//         </div>
//         <div><FieldLabel>Compliance Drop %</FieldLabel>
//           <Input type="number" value={editingDrift.compliance_drop_percentage} onChange={e => setEditingDrift(p => ({ ...p, compliance_drop_percentage: +e.target.value }))} />
//           <div style={{ fontSize: 10, color: T.muted, marginTop: 3 }}>Alert when compliance drops by this percentage</div>
//         </div>
//         <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, cursor: 'pointer' }}>
//           <input type="checkbox" checked={editingDrift.is_active === 1} onChange={e => setEditingDrift(p => ({ ...p, is_active: e.target.checked ? 1 : 0 }))} />
//           Enable Drift Detection
//         </label>
//       </Dialog>

//       {/* ── Top header bar ───────────────────────────────────────── */}
//       <div style={{ background: T.surface, borderBottom: `1px solid ${T.bdr}`, padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 14, flexShrink: 0 }}>
//         <button onClick={() => navigate('/vendors')} style={{ width: 34, height: 34, borderRadius: 7, border: `1px solid ${T.bdr}`, background: T.surface, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: T.slate, flexShrink: 0 }}>
//           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>
//         </button>

//         <div style={{ width: 40, height: 40, borderRadius: 10, background: T.blue, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, color: '#fff', flexShrink: 0, position: 'relative', overflow: 'hidden' }}>
//           <img
//             src={`https://www.google.com/s2/favicons?domain=${vendor.domain}&sz=40`}
//             alt=""
//             style={{ width: 40, height: 40, position: 'absolute', objectFit: 'contain' }}
//             onError={e => { (e.target as HTMLImageElement).style.display = 'none'; }}
//             onLoad={e => {
//               const parent = (e.target as HTMLImageElement).parentElement;
//               if (parent) { parent.style.background = 'transparent'; const t = parent.querySelector('span'); if (t) t.style.display = 'none'; }
//             }}
//           />
//           <span style={{ position: 'relative', zIndex: 1 }}>{initials}</span>
//         </div>

//         <div style={{ flex: 1, minWidth: 0 }}>
//           <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 2 }}>
//             <span style={{ fontSize: 16, fontWeight: 700, color: T.ink }}>{vendor.name}</span>
//             <span style={{ display: 'inline-flex', padding: '2px 8px', borderRadius: 3, background: T.grnBg, border: `1px solid ${T.grnBdr}`, fontSize: 9, fontWeight: 700, color: T.grn, letterSpacing: '.05em', fontFamily: mono }}>
//               {(vendor.status || 'ACTIVE').toUpperCase()}
//             </span>
//           </div>
//           <div style={{ fontSize: 11, color: T.muted }}>
//             {vendor.vendorId && `Vendor ID: ${vendor.vendorId}`}
//             {vendor.category && ` · Category: ${vendor.category}`}
//           </div>
//           <button style={{ fontSize: 11, color: T.blue, fontWeight: 500, background: 'none', border: 'none', cursor: 'pointer', fontFamily: sans, padding: 0, marginTop: 1 }}
//             onClick={() => window.open(`https://${vendor.domain}`, '_blank')}>
//             View vendor profile →
//           </button>
//         </div>

//         <div style={{ display: 'flex', gap: 28, alignItems: 'flex-start', marginRight: 12 }}>
//           {[
//             { label: 'Owner',          value: vendor.owner || '—' },
//             { label: 'Business Owner', value: vendor.businessOwner || '—' },
//             { label: 'Onboarded On',   value: vendor.onboardedAt ? fmtShort(vendor.onboardedAt) : fmtShort(vendor.createdAt) },
//           ].map(({ label, value }) => (
//             <div key={label} style={{ textAlign: 'center' }}>
//               <div style={{ fontSize: 9, fontWeight: 700, color: T.muted, letterSpacing: '.08em', textTransform: 'uppercase', marginBottom: 3 }}>{label}</div>
//               <div style={{ fontSize: 12, fontWeight: 600, color: T.ink }}>{value}</div>
//             </div>
//           ))}
//         </div>

//         <div style={{ display: 'flex', gap: 6 }}>
//           <button style={topBtn(true)} onClick={handleNewScan}>⊕ New Scan</button>
//           <button style={topBtn(false)}>↓ Export</button>
//           <button style={{ ...topBtn(false), padding: '7px 10px', color: T.slate }}>⋮</button>
//         </div>
//       </div>

//       {/* ── Nav tabs ──────────────────────────────────────────────── */}
//       <div style={{ background: T.surface, borderBottom: `1px solid ${T.bdr}`, padding: '0 20px', display: 'flex', flexShrink: 0 }}>
//         {(['overview','profile','assessments','documents','contacts','contracts','issues','history'] as const).map(t => (
//           <div key={t} onClick={() => setActiveTab(t)} style={{
//             padding: '10px 14px', fontSize: 12, fontWeight: 600,
//             color: activeTab === t ? T.blue : T.muted,
//             borderBottom: `2px solid ${activeTab === t ? T.blue : 'transparent'}`,
//             cursor: 'pointer', whiteSpace: 'nowrap', userSelect: 'none',
//           }}>
//             {t.charAt(0).toUpperCase() + t.slice(1)}
//           </div>
//         ))}
//       </div>

//       {/* ── Body ──────────────────────────────────────────────────── */}
//       <div style={{ flex: 1, overflowY: 'auto', padding: '14px 20px', display: 'flex', flexDirection: 'column', gap: 12 }}>
//         {activeTab === 'overview' && (
//           <>
//             {/* ── Row 1: Risk Score + Scan Analysis ── */}
//             <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
//               <div style={card}>
//                 <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
//                   <span style={cardLabel}>📊 Risk Score</span>
//                   <select style={{ fontSize: 10, border: `1px solid ${T.bdr}`, borderRadius: 4, padding: '2px 6px', color: T.slate, background: T.surface, fontFamily: sans }}>
//                     <option>Last 6 Months</option><option>Last 12 Months</option><option>All Time</option>
//                   </select>
//                 </div>
//                 <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
//                   <div style={{ flexShrink: 0 }}>
//                     <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginBottom: 10 }}>
//                       <span style={{ fontSize: 48, fontWeight: 800, lineHeight: 1, letterSpacing: -2, color: riskColor, fontFamily: mono }}>{vendor.score ?? '—'}</span>
//                       <span style={{ fontSize: 15, color: T.muted, fontWeight: 500, fontFamily: mono }}>/100</span>
//                     </div>
//                     <div style={{ width: 120, height: 5, borderRadius: 99, background: T.surface2, overflow: 'hidden', marginBottom: 12 }}>
//                       <div style={{ height: 5, borderRadius: 99, background: riskColor, width: `${vendor.score || 0}%`, transition: 'width .8s' }} />
//                     </div>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
//                       <RiskBadge level={vendor.riskLevel || 'Unknown'} />
//                       {prevScan && <TrendPill delta={scoreTrend} />}
//                       <span style={{ fontSize: 10, color: T.muted }}>{vendor.lastScan ? `Updated ${fmtShort(vendor.lastScan)}` : 'Never scanned'}</span>
//                     </div>
//                   </div>
//                   {trendScores.length > 0 && <TrendLineChart scores={trendScores} riskColor={riskColor} />}
//                 </div>
//               </div>

//               <div style={card}>
//                 <div style={cardLabel}>📈 Scan Analysis</div>
//                 <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8, marginBottom: 10 }}>
//                   {[
//                     { label: 'Total Scans',   value: String(scans.length),              color: T.ink,              sub: '' },
//                     { label: 'Average Score', value: avgScore    ? `${avgScore}`    : '—', color: scoreColor(avgScore),    sub: '/100' },
//                     { label: 'Best Score',    value: bestScore   ? `${bestScore}`   : '—', color: scoreColor(bestScore),   sub: '/100' },
//                     { label: 'Lowest Score',  value: lowestScore ? `${lowestScore}` : '—', color: scoreColor(lowestScore), sub: '/100' },
//                   ].map(({ label, value, color, sub }) => (
//                     <div key={label} style={{ background: T.surface2, borderRadius: 6, padding: '10px 12px', textAlign: 'center' }}>
//                       <div style={{ fontSize: 9, color: T.muted, letterSpacing: '.07em', textTransform: 'uppercase', marginBottom: 4 }}>{label}</div>
//                       <div style={{ fontSize: 18, fontWeight: 700, color, lineHeight: 1, fontFamily: mono }}>
//                         {value}<span style={{ fontSize: 10, color: T.muted, fontFamily: sans }}>{sub}</span>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//                 {monitoredSince && (
//                   <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', background: T.blueBg, borderRadius: 5, border: `1px solid ${T.blueBdr}`, fontSize: 11 }}>
//                     <span style={{ color: T.indigo }}>📅 Monitored Since</span>
//                     <strong style={{ color: T.blue }}>
//                       {fmtShort(monitoredSince)}
//                       {(monitoredYears > 0 || monitoredMonths > 0) && ` (${monitoredYears > 0 ? `${monitoredYears} Year${monitoredYears > 1 ? 's' : ''}` : `${monitoredMonths} Month${monitoredMonths > 1 ? 's' : ''}`})`}
//                     </strong>
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/*
//               ── Row 2+3: 3-column CSS grid layout ──
//               Col 1-2: Scan History (top) + Schedule Config (bottom)
//               Col 3:   Subdomain Inventory spanning both rows
//             */}
//             <div style={{
//               display: 'grid',
//               gridTemplateColumns: '1fr 1fr 1fr',
//               gridTemplateRows: 'auto auto',
//               gap: 12,
//             }}>

//               {/* ── Scan History — cols 1-2, row 1 ── */}
//               <div style={{ ...card, gridColumn: '1 / 3', gridRow: '1 / 2' }}>
//                 <div style={sectionHdr}>
//                   <span style={sectionTitle}>📋 Scan History</span>
//                   <button style={linkBtn} onClick={() => setActiveTab('history')}>View All</button>
//                 </div>
//                 <div style={{ border: `1px solid ${T.bdr}`, borderRadius: 6, overflow: 'hidden' }}>
//                   <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
//                     <colgroup>
//                       <col style={{ width: '22%' }} /><col style={{ width: '20%' }} />
//                       <col style={{ width: '16%' }} /><col style={{ width: '14%' }} />
//                       <col style={{ width: '14%' }} /><col style={{ width: '14%' }} />
//                     </colgroup>
//                     <thead>
//                       <tr>{['Scan Date','Scan Type','Risk Score','Risk Level','Status','Action'].map(h => <th key={h} style={th}>{h}</th>)}</tr>
//                     </thead>
//                     <tbody>
//                       {scans.length === 0 ? (
//                         <tr><td colSpan={6}>
//                           <div style={{ textAlign: 'center', padding: '32px 0' }}>
//                             <div style={{ fontSize: 13, fontWeight: 600, color: T.slate, marginBottom: 4 }}>No scans yet</div>
//                             <div style={{ fontSize: 11, color: T.muted }}>Click "New Scan" to start your first assessment.</div>
//                           </div>
//                         </td></tr>
//                       ) : scans.slice(0, 6).map((scan, idx) => {
//                         const scanId = scan.scan_id || scan.id;
//                         const dt = fmtDate(scan.completed_at || scan.created_at);
//                         return (
//                           <tr key={scanId}
//                             onMouseEnter={e => (e.currentTarget as HTMLElement).style.background = T.surface2}
//                             onMouseLeave={e => (e.currentTarget as HTMLElement).style.background = 'transparent'}
//                             style={{ transition: 'background .1s' }}>
//                             <td style={td}><div style={{ fontWeight: 600, fontSize: 11 }}>{dt.date}</div><div style={{ fontSize: 10, color: T.muted }}>{dt.time}</div></td>
//                             <td style={{ ...td, color: T.slate }}>{scan.scan_type || 'Risk Assessment'}</td>
//                             <td style={td}>
//                               <span style={{ fontSize: 13, fontWeight: 700, color: scoreColor(scan.overall_score), fontFamily: mono }}>{scan.overall_score}</span>
//                               <span style={{ fontSize: 10, color: T.muted }}>/100</span>
//                             </td>
//                             <td style={td}><RiskBadge level={scan.risk_level} /></td>
//                             <td style={td}>
//                               <span style={{ display: 'inline-flex', padding: '2px 8px', borderRadius: 3, background: T.grnBg, border: `1px solid ${T.grnBdr}`, fontSize: 9, fontWeight: 700, color: T.grn, letterSpacing: '.05em', fontFamily: mono }}>COMPLETED</span>
//                             </td>
//                             <td style={{ ...td, textAlign: 'center' }}>
//                               <button
//                                 onClick={() => handleViewScan(scanId)}
//                                 style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '4px 10px', borderRadius: 5, fontSize: 11, fontWeight: 500, border: `1px solid ${T.bdr}`, background: T.surface, color: T.ink, cursor: 'pointer', fontFamily: sans }}
//                                 onMouseEnter={e => { (e.currentTarget as HTMLElement).style.background = T.ink; (e.currentTarget as HTMLElement).style.color = '#fff'; }}
//                                 onMouseLeave={e => { (e.currentTarget as HTMLElement).style.background = T.surface; (e.currentTarget as HTMLElement).style.color = T.ink; }}
//                               >View ↗</button>
//                             </td>
//                           </tr>
//                         );
//                       })}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>

//               {/* ── Subdomain Inventory — col 3, rows 1-2 (spans both rows) ── */}
//               <div style={{ ...card, gridColumn: '3 / 4', gridRow: '1 / 3', display: 'flex', flexDirection: 'column' }}>
//                 <div style={sectionHdr}>
//                   <span style={sectionTitle}>🌐 Subdomains Inventory</span>
//                   <span style={{ fontSize: 11, color: T.muted }}>Total: {subdomains.length}</span>
//                 </div>

//                 {/* Summary counts */}
//                 <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 6, marginBottom: 12 }}>
//                   {[
//                     { count: subdomainCounts.production,     color: '#DC2626', bg: '#FEF2F2', icon: '🔴', label: 'Prod' },
//                     { count: subdomainCounts.non_production, color: '#D97706', bg: '#FFFBEB', icon: '🟡', label: 'Non-Prod' },
//                     { count: subdomainCounts.internal,       color: '#EA580C', bg: '#FFF7ED', icon: '🟠', label: 'Internal' },
//                     { count: subdomainCounts.unknown,        color: '#6B7280', bg: '#F3F4F6', icon: '⚪', label: 'Unknown' },
//                   ].map(({ count, color, bg, icon, label }) => (
//                     <div key={label} style={{ textAlign: 'center', padding: '6px 4px', background: bg, borderRadius: 4 }}>
//                       <div style={{ fontSize: 14, fontWeight: 700, color }}>{count}</div>
//                       <div style={{ fontSize: 8, color }}>{icon} {label}</div>
//                     </div>
//                   ))}
//                 </div>

//                 {/* Filter tabs */}
//                 <div style={{ display: 'flex', gap: 2, borderBottom: `1px solid ${T.bdr}`, marginBottom: 10 }}>
//                   {([
//                     { key: 'all',            label: `All (${subdomains.length})`,                 activeColor: T.blue    },
//                     { key: 'production',     label: `🔴 (${subdomainCounts.production})`,         activeColor: '#DC2626' },
//                     { key: 'non_production', label: `🟡 (${subdomainCounts.non_production})`,     activeColor: '#D97706' },
//                     { key: 'internal',       label: `🟠 (${subdomainCounts.internal})`,           activeColor: '#EA580C' },
//                   ] as const).map(tab => (
//                     <button key={tab.key} onClick={() => setSubdomainTab(tab.key)} style={{
//                       padding: '4px 8px', fontSize: '10px', fontWeight: 600,
//                       color: subdomainTab === tab.key ? tab.activeColor : T.muted,
//                       borderBottom: subdomainTab === tab.key ? `2px solid ${tab.activeColor}` : '2px solid transparent',
//                       background: 'none', border: 'none', cursor: 'pointer', fontFamily: sans,
//                     }}>{tab.label}</button>
//                   ))}
//                 </div>

//                 {/* Subdomain table — flex-grow to fill remaining height */}
//                 <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
//                   {loadingSubdomains ? (
//                     <div style={{ textAlign: 'center', padding: 16, color: T.muted, fontSize: 11 }}>Loading...</div>
//                   ) : getFilteredSubdomains().length === 0 ? (
//                     <div style={{ textAlign: 'center', padding: 16, color: T.muted, fontSize: 11 }}>No subdomains</div>
//                   ) : (
//                     <div style={{ border: `1px solid ${T.bdr}`, borderRadius: 4, overflow: 'auto', flex: 1 }}>
//                       <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 11 }}>
//                         <thead>
//                           <tr style={{ background: T.surface2, borderBottom: `1px solid ${T.bdr}` }}>
//                             <th style={{ padding: '6px 8px', textAlign: 'left', fontSize: 9, fontWeight: 600, color: T.muted }}>Subdomain</th>
//                             <th style={{ padding: '6px 8px', textAlign: 'left', fontSize: 9, fontWeight: 600, color: T.muted }}>Env</th>
//                             <th style={{ padding: '6px 8px', textAlign: 'center', fontSize: 9, fontWeight: 600, color: T.muted }}>Findings</th>
//                             <th style={{ padding: '6px 8px', textAlign: 'center', fontSize: 9, fontWeight: 600, color: T.muted }}>Actions</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {getFilteredSubdomains().map((sub, idx) => (
//                             <tr key={idx} style={{ borderBottom: `1px solid ${T.bdr}` }}>
//                               <td style={{ padding: '6px 8px', fontSize: 10, maxWidth: 130, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={sub.subdomain}>
//                                 {sub.subdomain.split('.')[0]}
//                               </td>
//                               <td style={{ padding: '6px 8px' }}>
//                                 {(() => {
//                                   const envConfig: Record<string, { icon: string; color: string }> = {
//                                     production:     { icon: '🔴', color: '#DC2626' },
//                                     non_production: { icon: '🟡', color: '#D97706' },
//                                     internal:       { icon: '🟠', color: '#EA580C' },
//                                     unknown:        { icon: '⚪', color: '#6B7280' },
//                                   };
//                                   const { icon } = envConfig[sub.environment] || envConfig.unknown;
//                                   return <span style={{ fontSize: 12 }}>{icon}{sub.is_override ? ' ✏️' : ''}</span>;
//                                 })()}
//                               </td>
//                               <td style={{ padding: '6px 8px', textAlign: 'center', fontSize: 10 }}>{sub.findings_count}</td>
//                               <td style={{ padding: '6px 8px', textAlign: 'center' }}>
//                                 <button onClick={() => { setEditingSubdomain(sub); setShowOverrideModal(true); }}
//                                   style={{ background: 'none', border: 'none', color: T.blue, cursor: 'pointer', fontSize: 11, marginRight: 4 }} title="Override">✏️</button>
//                                 {sub.is_override && (
//                                   <button onClick={() => handleRevertOverride(sub)}
//                                     style={{ background: 'none', border: 'none', color: T.red, cursor: 'pointer', fontSize: 11 }} title="Revert">↩️</button>
//                                 )}
//                               </td>
//                             </tr>
//                           ))}
//                         </tbody>
//                       </table>
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {/* ── Schedule Configuration — cols 1-2, row 2 ── */}
//               <div style={{ ...card, gridColumn: '1 / 3', gridRow: '2 / 3' }}>
//                 <div style={sectionHdr}>
//                   <span style={sectionTitle}>🗓 Schedule Configuration</span>
//                   <button style={{ ...linkBtn, color: T.slate }} onClick={() => setScheduleDialogOpen(true)}>✏ Edit</button>
//                 </div>
//                 <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
//                   <SchedItem icon="📅" label="Scan Frequency"      value={vendorSchedule?.frequency ? vendorSchedule.frequency.charAt(0).toUpperCase() + vendorSchedule.frequency.slice(1) : 'Quarterly'} />
//                   <SchedItem icon="🔍" label="Scan Type"           value={vendorSchedule?.scan_type || 'Risk Assessment'} />
//                   <SchedItem icon="⏱" label="Next Scheduled Scan" value={vendorSchedule?.next_run ? fmtShort(vendorSchedule.next_run) : '—'} />
//                   <SchedItem icon="🔔" label="Auto-Notify"         value={vendorSchedule?.auto_notify !== false ? 'Enabled' : 'Disabled'} />
//                   <SchedItem icon="📋" label="Last Scan"           value={latestScan ? fmtShort(latestScan.completed_at || latestScan.created_at) : '—'} />
//                   <SchedItem icon="👤" label="Assigned To"         value={vendorSchedule?.assigned_to || vendor.owner || '—'} />
//                 </div>
//               </div>

//             </div>{/* end 3-col grid */}

//             {/* ── Scan Comparison ── */}
//             <div style={card}>
//               <div style={sectionHdr}>
//                 <span style={sectionTitle}>📊 Scan Comparison</span>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
//                   <select value={compFilter} onChange={e => setCompFilter(e.target.value)}
//                     style={{ fontSize: 11, border: `1px solid ${T.bdr}`, borderRadius: 4, padding: '3px 8px', color: T.slate, background: T.surface, fontFamily: sans }}>
//                     <option>Compare by: Risk Score</option>
//                     <option>Compare by: Critical Issues</option>
//                   </select>
//                   <button style={linkBtn} onClick={() => setActiveTab('assessments')}>View Full Comparison →</button>
//                 </div>
//               </div>
//               {loadingComparison ? (
//                 <div style={{ textAlign: 'center', padding: '24px 0', color: T.muted, fontSize: 12 }}>Loading comparison…</div>
//               ) : (
//                 <ComparisonBarChart current={{ name: vendor.name, score: vendor.score || 0 }} peers={peers} />
//               )}
//             </div>

//             {/* ── Score Changes Between Scans ── */}
//             {comparison?.has_comparison && (
//               <div style={card}>
//                 <div style={sectionHdr}>
//                   <span style={sectionTitle}>📈 Score Changes Between Scans</span>
//                   <span style={{
//                     padding: '3px 10px', borderRadius: 4,
//                     background: comparison.score_change >= 0 ? T.grnBg : T.redBg,
//                     border: `1px solid ${comparison.score_change >= 0 ? T.grnBdr : T.redBdr}`,
//                     fontSize: 11, fontWeight: 600,
//                     color: comparison.score_change >= 0 ? T.grn : T.red,
//                   }}>
//                     Score: {comparison.previous_scan.score} → {comparison.latest_scan.score}
//                     {comparison.score_change >= 0 ? ` (+${comparison.score_change})` : ` (${comparison.score_change})`}
//                   </span>
//                 </div>

//                 <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 10, marginBottom: 16 }}>
//                   {[
//                     { label: 'Improved',   value: comparison.summary.improved_count, color: T.grn    },
//                     { label: 'Declined',   value: comparison.summary.declined_count, color: T.red    },
//                     { label: 'New Issues', value: comparison.summary.new_count,      color: T.amb    },
//                     { label: 'Resolved',   value: comparison.summary.resolved_count, color: '#059669' },
//                   ].map(({ label, value, color }) => (
//                     <div key={label} style={{ textAlign: 'center', padding: '10px 12px', background: T.surface2, borderRadius: 6 }}>
//                       <div style={{ fontSize: 22, fontWeight: 700, color, fontFamily: mono }}>{value}</div>
//                       <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>{label}</div>
//                     </div>
//                   ))}
//                 </div>

//                 {comparison.declined.length > 0 && (<>
//                   <div style={{ fontSize: 12, fontWeight: 700, color: T.red, marginBottom: 8 }}>▼ Worsened Indicators ({comparison.declined.length})</div>
//                   <CompTable rows={comparison.declined} headerBg={T.redBg} cols={[
//                     { label: 'Indicator', render: r => <span style={{ fontSize: 11, fontWeight: 600 }}>{r.indicator_name}</span> },
//                     { label: 'Category',  render: r => <span style={{ fontSize: 10, padding: '2px 7px', background: T.surface2, border: `1px solid ${T.bdr}`, borderRadius: 3 }}>{r.category}</span> },
//                     { label: 'Severity',  render: r => <SevChip sev={r.severity} /> },
//                     { label: 'Previous',  render: r => <span style={{ fontFamily: mono, color: T.red }}>{r.old_impact}</span> },
//                     { label: 'Current',   render: r => <span style={{ fontFamily: mono, color: T.red }}>{r.new_impact}</span> },
//                     { label: 'Change',    render: r => <span style={{ padding: '1px 7px', background: T.redBg, color: T.red, borderRadius: 3, fontFamily: mono, fontSize: 11, fontWeight: 700 }}>{r.change > 0 ? '+' : ''}{r.change}</span> },
//                   ]} />
//                 </>)}

//                 {comparison.improved.length > 0 && (<>
//                   <div style={{ fontSize: 12, fontWeight: 700, color: T.grn, marginBottom: 8 }}>▲ Improved Indicators ({comparison.improved.length})</div>
//                   <CompTable rows={comparison.improved} headerBg={T.grnBg} cols={[
//                     { label: 'Indicator', render: r => <span style={{ fontSize: 11, fontWeight: 600 }}>{r.indicator_name}</span> },
//                     { label: 'Category',  render: r => <span style={{ fontSize: 10, padding: '2px 7px', background: T.surface2, border: `1px solid ${T.bdr}`, borderRadius: 3 }}>{r.category}</span> },
//                     { label: 'Severity',  render: r => <SevChip sev={r.severity} /> },
//                     { label: 'Previous',  render: r => <span style={{ fontFamily: mono, color: T.grn }}>{r.old_impact}</span> },
//                     { label: 'Current',   render: r => <span style={{ fontFamily: mono, color: T.grn }}>{r.new_impact}</span> },
//                     { label: 'Change',    render: r => <span style={{ padding: '1px 7px', background: T.grnBg, color: T.grn, borderRadius: 3, fontFamily: mono, fontSize: 11, fontWeight: 700 }}>{r.change > 0 ? '+' : ''}{r.change}</span> },
//                   ]} />
//                 </>)}

//                 {comparison.new_issues.length > 0 && (<>
//                   <div style={{ fontSize: 12, fontWeight: 700, color: T.amb, marginBottom: 8 }}>⚠ New Issues ({comparison.new_issues.length})</div>
//                   <CompTable rows={comparison.new_issues} headerBg={T.ambBg} cols={[
//                     { label: 'Indicator', render: r => <div><div style={{ fontSize: 11, fontWeight: 600 }}>{r.indicator_name}</div><div style={{ fontSize: 10, color: T.slate, marginTop: 1 }}>{r.description}</div></div> },
//                     { label: 'Category',  render: r => <span style={{ fontSize: 10, padding: '2px 7px', background: T.surface2, border: `1px solid ${T.bdr}`, borderRadius: 3 }}>{r.category}</span> },
//                     { label: 'Severity',  render: r => <SevChip sev={r.severity} /> },
//                     { label: 'Impact',    render: r => <span style={{ fontFamily: mono, fontWeight: 700, color: T.red }}>{r.impact}</span> },
//                   ]} />
//                 </>)}

//                 {comparison.resolved.length > 0 && (<>
//                   <div style={{ fontSize: 12, fontWeight: 700, color: '#059669', marginBottom: 8 }}>✓ Resolved Issues ({comparison.resolved.length})</div>
//                   <CompTable rows={comparison.resolved} headerBg={T.grnBg} cols={[
//                     { label: 'Indicator',   render: r => <span style={{ fontSize: 11, fontWeight: 600 }}>{r.indicator_name}</span> },
//                     { label: 'Category',    render: r => <span style={{ fontSize: 10, padding: '2px 7px', background: T.surface2, border: `1px solid ${T.bdr}`, borderRadius: 3 }}>{r.category}</span> },
//                     { label: 'Prev Impact', render: r => <span style={{ fontFamily: mono, color: '#059669' }}>{r.old_impact}</span> },
//                     { label: 'Severity',    render: r => <SevChip sev={r.severity} /> },
//                   ]} />
//                 </>)}

//                 {comparison.scan_count === 1 && (
//                   <div style={{ textAlign: 'center', padding: 24, background: T.blueBg, border: `1px solid ${T.blueBdr}`, borderRadius: 6, fontSize: 12, color: T.blue }}>
//                     Need at least 2 scans to show comparison. Run another scan to see changes over time.
//                   </div>
//                 )}
//               </div>
//             )}

//             {/* ── Drift Detection ── */}
//             <div style={card}>
//               <div style={sectionHdr}>
//                 <span style={sectionTitle}>⚡ Drift Detection</span>
//                 <button style={{ ...linkBtn, color: T.slate }} onClick={() => setDriftDialogOpen(true)}>✏ Edit Settings</button>
//               </div>
//               <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 }}>
//                 {[
//                   { label: 'Score Threshold',  value: driftSettings?.score_threshold ?? 70,                  sub: 'Alert below this score',        color: (driftSettings?.score_threshold ?? 70) < 70 ? T.red : T.grn },
//                   { label: 'Risk Level Drift', value: driftSettings?.risk_level_drift ?? 2,                  sub: 'Alert when risk increases by X', color: T.amb },
//                   { label: 'Compliance Drop',  value: `${driftSettings?.compliance_drop_percentage ?? 15}%`, sub: 'Alert on % compliance drop',     color: '#8B5CF6' },
//                 ].map(({ label, value, sub, color }) => (
//                   <div key={label} style={{ textAlign: 'center', padding: '14px 12px', background: T.surface2, borderRadius: 6, border: `1px solid ${T.bdr}` }}>
//                     <div style={{ fontSize: 9, color: T.muted, letterSpacing: '.07em', textTransform: 'uppercase', marginBottom: 6 }}>{label}</div>
//                     <div style={{ fontSize: 26, fontWeight: 700, fontFamily: mono, color, lineHeight: 1, marginBottom: 4 }}>{value}</div>
//                     <div style={{ fontSize: 10, color: T.muted }}>{sub}</div>
//                   </div>
//                 ))}
//               </div>
//               <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 10, padding: '8px 12px', background: driftSettings?.is_active ? T.grnBg : T.redBg, borderRadius: 5, border: `1px solid ${driftSettings?.is_active ? T.grnBdr : T.redBdr}` }}>
//                 <span style={{ fontSize: 11, fontWeight: 600, color: driftSettings?.is_active ? T.grn : T.red }}>
//                   Drift Detection is {driftSettings?.is_active ? 'Enabled' : 'Disabled'}
//                 </span>
//                 <button style={{ ...linkBtn, color: driftSettings?.is_active ? T.grn : T.red }} onClick={() => setDriftDialogOpen(true)}>Configure →</button>
//               </div>
//             </div>
//           </>
//         )}

//         {/* ── History Tab ── */}
//         {activeTab === 'history' && (
//           <div style={card}>
//             <div style={{ ...sectionHdr, marginBottom: 12 }}>
//               <span style={sectionTitle}>📋 Full Scan History</span>
//               <span style={{ fontSize: 11, color: T.muted, fontFamily: mono }}>{scans.length} scan{scans.length !== 1 ? 's' : ''}</span>
//             </div>
//             <div style={{ border: `1px solid ${T.bdr}`, borderRadius: 6, overflow: 'hidden' }}>
//               <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
//                 <colgroup>
//                   <col style={{ width: '20%' }} /><col style={{ width: '20%' }} />
//                   <col style={{ width: '16%' }} /><col style={{ width: '14%' }} />
//                   <col style={{ width: '12%' }} /><col style={{ width: '18%' }} />
//                 </colgroup>
//                 <thead>
//                   <tr>{['Scan Date','Scan Type','Risk Score','Risk Level','Change','Action'].map(h => <th key={h} style={th}>{h}</th>)}</tr>
//                 </thead>
//                 <tbody>
//                   {scans.length === 0 ? (
//                     <tr><td colSpan={6} style={{ textAlign: 'center', padding: '48px 0' }}>
//                       <div style={{ fontSize: 14, fontWeight: 600, color: T.slate, marginBottom: 4 }}>No scans yet</div>
//                       <div style={{ fontSize: 12, color: T.muted }}>Click "New Scan" to run your first assessment.</div>
//                     </td></tr>
//                   ) : scans.map((scan, idx) => {
//                     const scanId    = scan.scan_id || scan.id;
//                     const prevScore = idx < scans.length - 1 ? scans[idx + 1]?.overall_score : null;
//                     const trend     = prevScore != null ? scan.overall_score - prevScore : null;
//                     const dt        = fmtDate(scan.completed_at || scan.created_at);
//                     return (
//                       <tr key={scanId}
//                         onMouseEnter={e => (e.currentTarget as HTMLElement).style.background = T.surface2}
//                         onMouseLeave={e => (e.currentTarget as HTMLElement).style.background = 'transparent'}
//                         style={{ transition: 'background .1s', borderBottom: `1px solid ${T.surface2}` }}>
//                         <td style={td}><div style={{ fontWeight: 600, fontSize: 12 }}>{dt.date}</div><div style={{ fontSize: 10, color: T.muted }}>{dt.time}</div></td>
//                         <td style={{ ...td, color: T.slate }}>{scan.scan_type || 'Risk Assessment'}</td>
//                         <td style={td}>
//                           <span style={{ fontSize: 13, fontWeight: 700, color: scoreColor(scan.overall_score), fontFamily: mono }}>{scan.overall_score}</span>
//                           <span style={{ fontSize: 10, color: T.muted }}>/100</span>
//                         </td>
//                         <td style={td}><RiskBadge level={scan.risk_level} /></td>
//                         <td style={td}>{trend != null ? <TrendPill delta={trend} /> : <span style={{ color: T.muted, fontSize: 11 }}>—</span>}</td>
//                         <td style={{ ...td, textAlign: 'center' }}>
//                           <button
//                             onClick={() => handleViewScan(scanId)}
//                             style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '5px 12px', borderRadius: 5, fontSize: 11, fontWeight: 500, border: `1px solid ${T.bdr}`, background: T.surface, color: T.ink, cursor: 'pointer', fontFamily: sans }}
//                             onMouseEnter={e => { (e.currentTarget as HTMLElement).style.background = T.ink; (e.currentTarget as HTMLElement).style.color = '#fff'; }}
//                             onMouseLeave={e => { (e.currentTarget as HTMLElement).style.background = T.surface; (e.currentTarget as HTMLElement).style.color = T.ink; }}
//                           >View Results ↗</button>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}

//         {(['profile','assessments','documents','contacts','contracts','issues'] as const).includes(activeTab as any) && (
//           <div style={{ ...card, textAlign: 'center', padding: '60px 0' }}>
//             <div style={{ fontSize: 14, fontWeight: 600, color: T.slate, marginBottom: 6 }}>{activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}</div>
//             <div style={{ fontSize: 12, color: T.muted }}>This section is under development.</div>
//           </div>
//         )}
//       </div>

//       {/* ── Footer ──────────────────────────────────────────────── */}
//       <div style={{ padding: '12px 20px', borderTop: `1px solid ${T.bdr}`, background: T.surface, display: 'flex', justifyContent: 'flex-end', gap: 8, flexShrink: 0 }}>
//         <button onClick={() => navigate('/vendors')} style={topBtn(false)}>← Back to Vendors</button>
//         <button onClick={handleNewScan} style={topBtn(true)}>⊕ Run New Scan</button>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { keepPreviousData, useMutation, useQuery } from '@tanstack/react-query';
import { remediationQueries, scanQueries, vendorQueries } from '../../lib/queries';
import { useTheme as useCustomTheme } from '../../context/ThemeContext';
import VendorContacts from './VendorContacts';
import VendorContracts from './VendorContracts';
import VendorAssessments from './VendorAssessments';
import VendorHistory from './VendorHistory';
import VendorDocuments from './VendorDocuments';
import VendorFourthParties from './VendorFourthParties';
import VendorIPAddresses from './VendorIPAddresses';
import VendorSecurityProfile from './VendorSecurityProfile';
import VendorProfile from './VendorProfile';
import VendorSchedulePage from './VendorSchedule';
import VendorQuestionnaires from './VendorQuestionnaires';
import VendorIssues from './VendorIssues';
import VendorDomains from './VendorDomains';
import VendorAccess from './VendorAccess';
import VendorRemediation from './VendorRemediation';
import ScanTypeButton, { ScanDepth, useVendorScan } from '../../components/ScanTypeButton';
import { LinkedInIcon } from '../../components/LinkedInField';
import { useAuth } from '../../context/AuthContext';


/* ─── Font injection ─────────────────────────────────────────────── */
if (typeof document !== 'undefined' && !document.getElementById('vd-fonts')) {
  const link = document.createElement('link');
  link.id = 'vd-fonts';
  link.rel = 'stylesheet';
  link.href =
    'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=JetBrains+Mono:wght@400;600;700&display=swap';
  document.head.appendChild(link);
}

/* ─── Design tokens ─────────────────────────────────────────────── */
export const T = {
  ink:      '#0F172A',
  ink2:     '#1E293B',
  slate:    '#64748B',
  muted:    '#94A3B8',
  faint:    '#CBD5E1',
  bg:       '#F5F6FA',
  surface:  '#FFFFFF',
  surface2: '#F8FAFC',
  bdr:      '#E2E8F0',
  red:    '#DC2626', redBg:  '#FEF2F2', redBdr:  '#FECACA',
  amb:    '#B45309', ambBg:  '#FFFBEB', ambBdr:  '#FDE68A',
  grn:    '#15803D', grnBg:  '#F0FDF4', grnBdr:  '#BBF7D0',
  blue:   '#3B82F6', blueBg: '#EFF6FF', blueBdr: '#BFDBFE',
  indigo: '#1E40AF',
};

const mono = "'JetBrains Mono', monospace";
export const sans = "'Inter', system-ui, sans-serif";

export const VENDOR_TABS = ['overview', 'domains', 'ip-addresses', 'fourth-parties', 'security-profile', 'questionnaires', 'profile', 'schedule', 'assessments', 'documents', 'contacts', 'access', 'contracts', 'issues', 'remediation', 'history'] as const;
export type VendorTab = typeof VENDOR_TABS[number];

const NO_SCANS: Scan[] = [];

/* ─── Types ──────────────────────────────────────────────────────── */
interface Vendor {
  id: string;
  name: string;
  domain: string;
  score: number;
  riskLevel: string;
  lastScan: string;
  createdAt: string;
  owner?: string;
  businessOwner?: string;
  onboardedAt?: string;
  category?: string;
  vendorId?: string;
  status?: string;
  linkedinUrl?: string | null;
  linkedinSource?: 'website' | 'manual' | null;
}

interface Scan {
  id: string;
  scan_id: string;
  domain: string;
  overall_score: number;
  risk_level: string;
  created_at: string;
  completed_at: string;
  scan_type?: string;
}

interface ComparisonScan { id: string; date: string; score: number; risk_level: string; scan_type?: string }

interface ScanComparison {
  has_comparison: boolean;
  scan_count?: number;
  message?: string;
  scans: ComparisonScan[];
  trend: Array<{ id: string; date: string; score: number }>;
  base_scan: ComparisonScan;
  head_scan: ComparisonScan;
  score_change: number;
  indicator_total: { from: number; to: number };
  severity: Record<'critical' | 'high' | 'medium' | 'low', { from: number; to: number }>;
  categories: Array<{ name: string; from: number | null; to: number | null; change: number | null }>;
  improved: Array<{ indicator_name: string; category: string; old_impact: number; new_impact: number; change: number; severity: string }>;
  declined: Array<{ indicator_name: string; category: string; old_impact: number; new_impact: number; change: number; severity: string }>;
  new_findings: Array<{ indicator_name: string; category: string; impact: number; severity: string; description: string }>;
  resolved: Array<{ indicator_name: string; category: string; old_impact: number; severity: string }>;
  summary: { improved_count: number; declined_count: number; new_count: number; resolved_count: number };
}

export interface Subdomain {
  subdomain: string;
  auto_environment: string;
  environment: string;
  is_override: boolean;
  override_reason: string | null;
  findings_count: number;
  scanned?: boolean;
  ip?: string | null;
  provider?: string | null;
  records?: string[];
  resolves?: boolean | null;
  overall_score?: number | null;
  risk_level?: string | null;
}

interface CompanyProfile {
  summary: string | null;
  mode: 'ai' | 'template' | null;
  generated_at: string | null;
  sources: Array<{ label: string; url: string | null }>;
  // services/company_research.py _structured_facts: e.g. employees, annual_revenue -- each with where it came from.
  facts?: Record<string, { value: string; source: string; url: string | null }>;
  stale: boolean;
}

interface Posture {
  has_scan: boolean;
  scan_id: string | null;
  scan_date: string | null;
  score: number | null;
  risk_level: string | null;
  previous_score: number | null;
  indicator_total: number;
  counts: { critical: number; high: number; medium: number; low: number };
  category_scores: Record<string, number>;
  // score_gain_if_fixed: points the overall score would rise if only this finding were fixed (real formula re-run).
  top_findings: Array<{ name: string; category: string | null; severity: string; score_gain_if_fixed?: number }>;
  vendor: {
    category: string | null;
    business_units: string[];
    location: string | null;
    parent_company: string | null;
    vendor_since: string | null;
    contract_end_date: string | null;
    contract_value?: number | null;
    auto_renew: boolean;
  };
  // backend/services/vendor_overview.py -- each part is null when its lookup failed or has nothing to show.
  glance?: {
    inherent_risk: { tier: string | null; assessed: boolean; drivers: string[] } | null;
    remediation: { open: number; awaiting_review: number; serious_unassigned: number } | null;
    fourth_parties: { companies: number; shared: number } | null;
    questionnaire: { id: string; name: string; status: string; answered: number; total: number; percent: number; due_date: string | null; sent_count: number } | null;
    next_scan_at: string | null;
    contract_days_left: number | null;
  };
  scans?: {
    total: number;
    recent: Array<{ id: string; date: string | null; scan_type: string | null; score: number | null; risk_level: string | null;
                    trigger_source: string | null; triggered_by_name: string | null }>;
  };
}

// Semantic colour chips for the Overview (colour = meaning, white cards; see the dashboard's exposure card).
type ToneName = 'green' | 'blue' | 'red' | 'amber' | 'purple' | 'slate';
const toneOf = (name: ToneName, isDark: boolean): [string, string, string] => ({
  green:  isDark ? ['#0a1a0a', '#4ADE80', '#15803D55'] : [T.grnBg, T.grn, T.grnBdr],
  blue:   isDark ? ['#0a1628', '#60A5FA', '#3B82F655'] : [T.blueBg, '#1D4ED8', T.blueBdr],
  red:    isDark ? ['#1a0a0a', '#F87171', '#DC262655'] : [T.redBg, T.red, T.redBdr],
  amber:  isDark ? ['#1a1408', '#FBBF24', '#B4530955'] : [T.ambBg, T.amb, T.ambBdr],
  purple: isDark ? ['#16112b', '#A78BFA', '#6D28D955'] : ['#F5F3FF', '#6D28D9', '#DDD6FE'],
  slate:  isDark ? ['#111111', '#94a3b8', '#1f1f1f'] : [T.surface2, T.slate, T.bdr],
} as Record<ToneName, [string, string, string]>)[name];
function Tone({ name, isDark, children }: { name: ToneName; isDark: boolean; children: React.ReactNode }) {
  const [bg, fg, bdr] = toneOf(name, isDark);
  return (
    <span style={{ display: 'inline-block', maxWidth: '100%', fontSize: 11.5, fontWeight: 600, padding: '2px 9px', borderRadius: 99, background: bg, color: fg, border: `1px solid ${bdr}`, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', verticalAlign: 'middle' }}>
      {children}
    </span>
  );
}

// Mirrors backend/services/financial_exposure.py's estimate_financial_exposure() return shape --
// a discriminated union on `available`, since the backend withholds the estimate entirely (rather
// than a $0 or industry-average-only number) until the vendor has BOTH a completed scan and a
// submitted/reviewed questionnaire response.
interface UnavailableExposure {
  available: false;
  has_scan: boolean;
  has_questionnaire: boolean;
  missing: string[];
  reason: string;
  sources: Array<{ name: string; publisher: string; year: number; note: string }>;
  disclaimer: string;
}
interface AvailableExposure {
  available: true;
  industry_sector: string | null;
  industry_label: string;
  industry_average_cost_usd_millions: number;
  industry_average_cost_prior_year_usd_millions: number;
  risk_level: string | null;
  risk_adjustment_multiplier: number;
  risk_adjustment_note: string;
  estimated_exposure_usd_millions: number;
  exposure_range: { minimum: number; likely: number; maximum: number; note: string };
  records_bucket: string | null;
  records_bucket_label: string | null;
  records_bucket_note: string | null;
  // backend/services/exposure_factors.py: IBM Figure 33 cost factors evidenced by this vendor's answers and scan.
  vendor_factors?: {
    multiplier: number; raw_multiplier: number; capped: boolean; note: string;
    has_questionnaire: boolean; has_scan: boolean;
    questionnaires: Array<{ name: string; status: string; answered_at: string | null }>;
    factors: Array<{
      key: string; label: string; ibm_usd: number; effect_pct: number;
      status: 'applied' | 'not_in_place' | 'disputed' | 'contradicted_by_scan' | 'no_evidence';
      source: 'questionnaire' | 'scan' | 'both' | 'none';
      evidence: Array<{ question?: string; answer?: string; questionnaire?: string; finding?: string; severity?: string }>;
    }>;
    source: string;
  };
  dbir_context: {
    naics_label: string; incidents: number; confirmed_breaches: number; top_patterns: string;
    vulnerability_exploitation_pct: number | null; third_party_pct: number | null; human_element_pct: number | null;
    note?: string;
  } | null;
  global_context: { global_average_cost_usd_millions: number; mean_days_to_identify_and_contain: number; cost_per_record_customer_pii_usd: number };
  sources: Array<{ name: string; publisher: string; year: number; note: string }>;
  disclaimer: string;
}
type FinancialExposure = UnavailableExposure | AvailableExposure;


/* ─── Helpers ────────────────────────────────────────────────────── */
const scoreColor = (s: number) =>
  s >= 80 ? T.grn : s >= 60 ? T.amb : s >= 40 ? '#C2410C' : T.red;

const getRiskCfg = (level: string) => {
  const l = (level || '').toLowerCase();
  if (l === 'high' || l === 'critical')
    return { bg: T.redBg, bdr: T.redBdr, text: T.red, label: level };
  if (l === 'medium')
    return { bg: T.ambBg, bdr: T.ambBdr, text: T.amb, label: level };
  if (l === 'low')
    return { bg: T.grnBg, bdr: T.grnBdr, text: T.grn, label: level };
  return { bg: T.surface2, bdr: T.bdr, text: T.slate, label: level || 'Unknown' };
};

const RiskBadge = ({ level, isDark }: { level: string; isDark?: boolean }) => {
  const cfg = getRiskCfg(level);
  const bg = isDark ? `${cfg.text}20` : cfg.bg;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      padding: '3px 9px', borderRadius: 5,
      background: bg, border: `1px solid ${isDark ? cfg.text + '40' : cfg.bdr}`,
      fontSize: 11, fontWeight: 600, color: cfg.text,
    }}>{cfg.label}</span>
  );
};





/* ─── Shared card style ──────────────────────────────────────────── */
export const card = (isDark: boolean): React.CSSProperties => ({
  background: isDark ? '#0d0d0d' : T.surface,
  border: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`,
  borderRadius: 8,
  padding: 16,
});
export const cardLabel = (isDark: boolean): React.CSSProperties => ({
  fontSize: 9, fontWeight: 700, color: isDark ? '#94a3b8' : T.muted, letterSpacing: '.09em',
  textTransform: 'uppercase', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 5,
});
const sectionHdr: React.CSSProperties = {
  display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10,
};
const sectionTitle = (isDark: boolean): React.CSSProperties => ({
  fontSize: 12, fontWeight: 700, color: isDark ? '#e2e8f0' : T.ink,
});
export const th = (isDark: boolean): React.CSSProperties => ({
  padding: '8px 12px', textAlign: 'left', fontSize: 9, fontWeight: 700,
  letterSpacing: '.08em', color: isDark ? '#94a3b8' : T.muted, textTransform: 'uppercase',
  background: isDark ? '#1a1a1a' : T.surface2, borderBottom: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`,
});
export const td = (isDark: boolean): React.CSSProperties => ({
  padding: '9px 12px', fontSize: 12, color: isDark ? '#e2e8f0' : T.ink, borderBottom: `1px solid ${isDark ? '#1f1f1f' : T.surface2}`, verticalAlign: 'middle',
});
export const topBtn = (primary: boolean, isDark: boolean): React.CSSProperties => ({
  display: 'flex', alignItems: 'center', gap: 6,
  padding: '7px 14px', borderRadius: 5, fontSize: 12, fontWeight: 600,
  cursor: 'pointer', fontFamily: sans, border: primary ? 'none' : `1px solid ${isDark ? '#1f1f1f' : T.bdr}`,
  background: primary ? (isDark ? '#3B82F6' : T.ink) : (isDark ? '#0d0d0d' : T.surface),
  color: primary ? '#fff' : (isDark ? '#e2e8f0' : T.ink),
});
export const linkBtn = (isDark: boolean): React.CSSProperties => ({
  fontSize: 11, color: isDark ? '#3B82F6' : T.blue, fontWeight: 600, cursor: 'pointer', background: 'none', border: 'none', fontFamily: sans,
});

/* ─── Dialog ─────────────────────────────────────────────────────── */
const Dialog = ({ open, onClose, title, children, onSave, saving, isDark }: {
  open: boolean; onClose: () => void; title: string;
  children: React.ReactNode; onSave: () => void; saving: boolean; isDark?: boolean;
}) => {
  if (!open) return null;
  const colors = {
    bg: isDark ? '#0d0d0d' : T.surface,
    border: isDark ? '#1f1f1f' : T.bdr,
    text: isDark ? '#e2e8f0' : T.ink,
    muted: isDark ? '#94a3b8' : T.muted,
    surface2: isDark ? '#1a1a1a' : T.surface2,
  };
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999 }}>
      <div style={{ background: colors.bg, border: `1px solid ${colors.border}`, borderRadius: 10, width: 480, maxWidth: '96vw', boxShadow: '0 8px 32px rgba(0,0,0,.12)' }}>
        <div style={{ padding: '16px 20px', borderBottom: `1px solid ${colors.border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontSize: 14, fontWeight: 700, color: colors.text }}>{title}</span>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 20, color: colors.muted, lineHeight: 1 }}>×</button>
        </div>
        <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: 14 }}>{children}</div>
        <div style={{ padding: '14px 20px', borderTop: `1px solid ${colors.border}`, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button onClick={onClose} style={{ ...topBtn(false, !!isDark), padding: '6px 16px' }}>Cancel</button>
          <button onClick={onSave} disabled={saving} style={{ ...topBtn(true, !!isDark), padding: '6px 16px', opacity: saving ? .6 : 1 }}>
            {saving ? 'Saving…' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

const FieldLabel = ({ children, isDark }: { children: React.ReactNode; isDark?: boolean }) => (
  <label style={{ fontSize: 11, fontWeight: 600, color: isDark ? '#94a3b8' : T.slate, letterSpacing: '.05em', marginBottom: 4, display: 'block' }}>{children}</label>
);
const SelectEl = (props: React.SelectHTMLAttributes<HTMLSelectElement> & { children: React.ReactNode; isDark?: boolean }) => (
  <select {...props} style={{ 
    width: '100%', 
    border: `1px solid ${props.isDark ? '#1f1f1f' : T.bdr}`, 
    borderRadius: 5, 
    padding: '7px 10px', 
    fontSize: 12, 
    color: props.isDark ? '#e2e8f0' : T.slate, 
    background: props.isDark ? '#0d0d0d' : T.surface, 
    outline: 'none', 
    fontFamily: sans, 
    cursor: 'pointer', 
    ...props.style 
  }}>
    {props.children}
  </select>
);

/* ─── Subdomain Override Modal ───────────────────────────────────── */
export const SubdomainOverrideModal = ({ open, onClose, subdomain, currentEnv, onSave, saving, isDark }: {
  open: boolean;
  onClose: () => void;
  subdomain: Subdomain | null;
  currentEnv: string;
  onSave: (environment: string, reason: string) => void;
  saving: boolean;
  isDark?: boolean;
}) => {
  const [selectedEnv, setSelectedEnv] = useState(currentEnv);
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (open) {
      setSelectedEnv(currentEnv);
      setReason(subdomain?.override_reason || '');
    }
  }, [open, currentEnv, subdomain]);

  if (!open || !subdomain) return null;

  const colors = {
    bg: isDark ? '#0d0d0d' : T.surface,
    border: isDark ? '#1f1f1f' : T.bdr,
    text: isDark ? '#e2e8f0' : T.ink,
    muted: isDark ? '#94a3b8' : T.muted,
    surface2: isDark ? '#1a1a1a' : T.surface2,
  };

  const environments = [
    { value: 'production',     label: '🔴 Production' },
    { value: 'non_production', label: '🟡 Non-Production' },
    { value: 'internal',       label: '🟠 Internal' },
    { value: 'unknown',        label: '⚪ Unknown' },
  ];

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: colors.bg, border: `1px solid ${colors.border}`, borderRadius: 10, width: 450, maxWidth: '96vw', boxShadow: '0 8px 32px rgba(0,0,0,.12)' }}>
        <div style={{ padding: '16px 20px', borderBottom: `1px solid ${colors.border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontSize: 14, fontWeight: 700, color: colors.text }}>Override Subdomain: {subdomain.subdomain}</span>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 20, color: colors.muted, lineHeight: 1 }}>×</button>
        </div>
        <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div>
            <FieldLabel isDark={isDark}>Current Classification</FieldLabel>
            <div style={{ padding: '8px 12px', background: colors.surface2, borderRadius: 5, fontSize: 12, color: colors.text }}>
              Auto-detected: <strong>{subdomain.auto_environment}</strong>
              {subdomain.is_override && <span style={{ marginLeft: 8, color: T.blue }}>✏️ Overridden</span>}
            </div>
          </div>
          <div>
            <FieldLabel isDark={isDark}>Override Environment</FieldLabel>
            <SelectEl
              value={selectedEnv}
              onChange={e => setSelectedEnv(e.target.value)}
              isDark={isDark}
            >
              {environments.map(env => (
                <option key={env.value} value={env.value}>{env.label}</option>
              ))}
            </SelectEl>
          </div>
          <div>
            <FieldLabel isDark={isDark}>Reason (Optional)</FieldLabel>
            <textarea
              value={reason}
              onChange={e => setReason(e.target.value)}
              placeholder="Why are you overriding this classification?"
              style={{ 
                width: '100%', 
                border: `1px solid ${colors.border}`, 
                borderRadius: 5, 
                padding: '8px 12px', 
                fontSize: 12, 
                fontFamily: sans, 
                minHeight: 80, 
                resize: 'vertical',
                background: colors.surface2,
                color: colors.text,
              }}
            />
          </div>
        </div>
        <div style={{ padding: '14px 20px', borderTop: `1px solid ${colors.border}`, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button onClick={onClose} style={{ ...topBtn(false, !!isDark), padding: '6px 16px' }}>Cancel</button>
          <button onClick={() => onSave(selectedEnv, reason)} disabled={saving} style={{ ...topBtn(true, !!isDark), padding: '6px 16px', opacity: saving ? .6 : 1 }}>
            {saving ? 'Saving…' : 'Save Override'}
          </button>
        </div>
      </div>
    </div>
  );
};

/* ─── Main Component ─────────────────────────────────────────────── */
// Tabs that make sense for the tenant's own company on My Risk (no contracts, contacts, questionnaires,
// remediation requests or relationship profile -- those are about managing a vendor).
export default function VendorDetails({ selfVendorId, selfActions }: { selfVendorId?: string; selfActions?: React.ReactNode } = {}) {
  const params = useParams();
  const vendorId = selfVendorId ?? params.vendorId;
  const isSelf = !!selfVendorId;
  const navigate     = useNavigate();
  const location     = useLocation();

  // ─── Theme Colors ──────────────────────────────────────────────────────────
  const { mode } = useCustomTheme();
  const isDark = mode === 'dark';

  const themeColors = {
    text: isDark ? '#e2e8f0' : '#0F172A',
    muted: isDark ? '#94a3b8' : '#64748B',
    background: isDark ? '#000000' : '#F5F6FA',
    cardBg: isDark ? '#0d0d0d' : '#FFFFFF',
    border: isDark ? '#1f1f1f' : '#E2E8F0',
    hover: isDark ? '#141414' : '#F8FAFC',
    paper: isDark ? '#0d0d0d' : '#FFFFFF',
    inputBg: isDark ? '#0d0d0d' : '#FFFFFF',
    surface: isDark ? '#0d0d0d' : '#FFFFFF',
    surface2: isDark ? '#1a1a1a' : '#F8FAFC',
  };

  const vendorQuery = useQuery({
    queryKey: ['vendors', 'detail', vendorId],
    queryFn: async () => (await api.get(`/v1/vendors/${vendorId}`)).data as Vendor,
    enabled: !!vendorId,
  });
  const vendor = vendorQuery.data ?? null;
  const scansQuery = useQuery({ ...scanQueries.byDomain(vendor?.domain ?? ''), enabled: !!vendor?.domain });
  const scans = (scansQuery.data ?? NO_SCANS) as Scan[];
  const loading = vendorQuery.isPending || (!!vendor?.domain && scansQuery.isPending);
  const error = vendorQuery.isError ? 'Failed to load vendor details' : null;

  // Which two scans the comparison card shows; empty = latest vs the one before it.
  const [compPair, setCompPair] = useState<{ base?: string; head?: string }>({});
  const comparisonQuery = useQuery({
    queryKey: ['vendors', 'detail', vendorId, 'scan-comparison', compPair.base ?? null, compPair.head ?? null],
    queryFn: async () => (await api.get(`/v1/vendors/${vendorId}/scan-comparison`, { params: compPair })).data as ScanComparison,
    enabled: !!vendorId,
    placeholderData: keepPreviousData,
  });
  const comparison = comparisonQuery.data ?? null;
  const loadingComparison = comparisonQuery.isPending || comparisonQuery.isPlaceholderData;
  const fetchScanComparison = (base?: string, head?: string) => setCompPair({ base, head });

  const postureQuery = useQuery({
    queryKey: ['vendors', 'detail', vendorId, 'posture-summary'],
    queryFn: async () => (await api.get(`/v1/vendors/${vendorId}/posture-summary`)).data as Posture,
    enabled: !!vendorId,
  });
  const posture = postureQuery.data ?? null;
  const scanTotal = posture?.scans?.total ?? scans.length;

  const exposureQuery = useQuery({
    queryKey: ['vendors', 'detail', vendorId, 'financial-exposure'],
    queryFn: async () => (await api.get(`/v1/vendors/${vendorId}/financial-exposure`)).data as FinancialExposure,
    enabled: !!vendorId,
  });
  const exposure = exposureQuery.data ?? null;

  // ── Overview extras ──
  // The latest scan against the one before it: the same cache entry as the comparison card's default pair, so the
  // header's "new / fixed since the last scan" and the card agree. Plus what is already in a remediation request,
  // every vendor's score (for "higher than N of your vendors"), and the rating if the top critical/high findings
  // were fixed (the remediation preview: the real scoring formula, read-only).
  const defaultComparisonQuery = useQuery({
    queryKey: ['vendors', 'detail', vendorId, 'scan-comparison', null, null],
    queryFn: async () => (await api.get(`/v1/vendors/${vendorId}/scan-comparison`, { params: {} })).data as ScanComparison,
    enabled: !!vendorId,
  });
  const lastChange = defaultComparisonQuery.data?.has_comparison ? defaultComparisonQuery.data : null;
  const vendorRisksQuery = useQuery({ ...remediationQueries.vendorRisks(vendorId ?? ''), enabled: !!vendorId && !isSelf });
  const inRemediation: Record<string, { request_id: string; title: string; status: string }> = vendorRisksQuery.data || {};
  const vendorListQuery = useQuery(vendorQueries.list());
  const seriousNames = (posture?.top_findings || []).filter(f => f.severity === 'Critical' || f.severity === 'High').map(f => f.name);
  const fixPreviewQuery = useQuery({
    queryKey: ['remediation', 'preview', vendorId, seriousNames.join('|')],
    queryFn: async () => {
      const params = new URLSearchParams({ vendor_id: vendorId ?? '' });
      seriousNames.forEach(n => params.append('risks', n));
      return (await api.get(`/v1/remediation/preview?${params.toString()}`)).data as { current_score: number | null; projected_score: number | null };
    },
    enabled: !!vendorId && !isSelf && seriousNames.length > 0,
    staleTime: 60_000,
  });
  const [trendRange, setTrendRange] = useState<'3M' | '6M' | '12M' | 'All'>('6M');
  const [comparisonOpen, setComparisonOpen] = useState(true);
  const [catShowAll, setCatShowAll] = useState(false);
  const openComparison = () => {
    setComparisonOpen(true);
    setTimeout(() => document.getElementById('ov-comparison')?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);
  };
  // The URL's ?tab= wins over navigation state: it's kept in step with the open tab (effect below), so a refresh
  // reopens the tab the user was on. Navigation state (links like "Edit profile") only seeds the first visit --
  // history state survives a reload, so checking it first would send a refresh back to the linked tab.
  const [activeTab,          setActiveTab]          = useState<VendorTab>(() => {
    const requested = new URLSearchParams(location.search).get('tab') ?? (location.state as { tab?: string } | null)?.tab;
    return VENDOR_TABS.includes(requested as VendorTab) ? requested as VendorTab : 'overview';
  });
  // Keep ?tab= in the URL in step with the open tab (replace, so tab clicks don't pile up in Back history).
  // Overview is the default and leaves the URL clean; ?request= only belongs to the Remediation tab.
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (activeTab === 'overview') params.delete('tab'); else params.set('tab', activeTab);
    if (activeTab !== 'remediation') params.delete('request');
    const search = params.toString() ? `?${params.toString()}` : '';
    if (search !== location.search) navigate({ search }, { replace: true, state: location.state });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);
  // The remediation request open in the Remediation tab (?tab=remediation&request=<id>); null shows the tab's list.
  const [remediationRequestId, setRemediationRequestId] = useState<string | null>(() => new URLSearchParams(location.search).get('request'));
  const openRemediationRequest = (requestId: string | null) => {
    setRemediationRequestId(requestId);
    setActiveTab('remediation');
    navigate({ search: `?tab=remediation${requestId ? `&request=${requestId}` : ''}` }, { replace: true });
  };
  const [companyProfile, setCompanyProfile] = useState<CompanyProfile | null>(null);
  const [companyProfileLoading, setCompanyProfileLoading] = useState(false);

  // The live company research is expensive, so it is fetched on demand only -- not refreshed by change events.
  // A new name or domain (e.g. My Organization edited in place) is a different company, so it is researched again.
  useEffect(() => {
    if (vendorId && vendor) {
      setCompanyProfile(null);
      fetchCompanyProfile();
    }
  }, [vendorId, vendor?.name, vendor?.domain]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchCompanyProfile = async (refresh = false) => {
    if (!vendorId) return;
    setCompanyProfileLoading(true);
    try {
      const { data } = await api.get(`/v1/vendors/${vendorId}/company-profile`, { params: refresh ? { refresh: true } : undefined, timeout: 70000 });
      setCompanyProfile(data);
    } catch { /* keep whatever is shown; the About text falls back to the vendor record */ }
    finally { setCompanyProfileLoading(false); }
  };


  // Scans start right here at the depth the user picks (Fast / Deep) and open the progress page; there is no
  // separate Scan page any more. Viewers can't start scans (the API refuses), so they don't get the button.
  const { user: authUser } = useAuth();
  const canScan = !!authUser && authUser.role !== 'viewer';
  const [scanError, setScanError] = useState<string | null>(null);
  const vendorScan = useVendorScan();
  const handleNewScan = (depth: ScanDepth = 'fast') => {
    if (!vendorId) return;
    setScanError(null);
    vendorScan.mutate({ vendorId, depth }, { onError: (e: any) => {
      const d = e?.response?.data?.detail;
      setScanError(typeof d === 'string' ? d : (d && typeof d === 'object' && typeof d.message === 'string') ? d.message : 'Could not start the scan.');
    } });
  };
  const handleViewScan = (scanId: string) => navigate(`/scans/${scanId}/results`);

  const fmtDate = (raw: string) => {
    const d = new Date(raw);
    return {
      date: d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
      time: d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }),
    };
  };
  const fmtShort = (raw?: string) =>
    raw ? new Date(raw).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—';

  const getEnvironmentBadge = (environment: string, isOverride = false) => {
    const config: Record<string, { icon: string; color: string; bg: string; label: string }> = {
      production:     { icon: '🔴', color: '#DC2626', bg: isDark ? '#1a0a0a' : '#FEF2F2', label: 'Production' },
      non_production: { icon: '🟡', color: '#D97706', bg: isDark ? '#1a1400' : '#FFFBEB', label: 'Non-Production' },
      internal:       { icon: '🟠', color: '#EA580C', bg: isDark ? '#1a0f00' : '#FFF7ED', label: 'Internal' },
      unknown:        { icon: '⚪', color: '#6B7280', bg: isDark ? '#1a1a1a' : '#F3F4F6', label: 'Unknown' },
    };
    const { icon, color, bg, label } = config[environment] || config.unknown;
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '2px 8px', borderRadius: 4, background: bg, border: `1px solid ${color}20`, fontSize: 11, fontWeight: 500, color }}>
        {icon} {label}{isOverride && <span style={{ fontSize: 9 }}>✏️</span>}
      </span>
    );
  };

  /* ── Derived ──────────────────────────────────────────────────── */
  const latestScan  = scans[0];
  const prevScan    = scans[1];
  const scoreTrend  = prevScan ? (latestScan?.overall_score ?? 0) - (prevScan?.overall_score ?? 0) : 0;

  const firstScanDate = scans.length
    ? scans.reduce((oldest, s) => new Date(s.completed_at || s.created_at) < new Date(oldest.completed_at || oldest.created_at) ? s : oldest).completed_at || scans[scans.length - 1].created_at
    : vendor?.createdAt;

  const monitoredSince  = firstScanDate || vendor?.createdAt;


  {/* ── Loading / Error ──────────────────────────────────────────── */}
if (loading) return (
  <div style={{ fontFamily: sans, background: isDark ? '#000000' : T.bg, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 12 }}>
    <style>{`@keyframes slide{from{transform:translateX(-40px)}to{transform:translateX(80px)}}`}</style>
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={T.blue} strokeWidth="1.5">
      <path d="M10 2L3 5v5c0 4.1 3 7.9 7 9 4-1.1 7-4.9 7-9V5L10 2z"/>
      <path d="M7 12l2 2 5-5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
    <span style={{ fontFamily: mono, fontSize: 11, color: isDark ? '#94a3b8' : T.slate, letterSpacing: '.12em' }}>{isSelf ? 'LOADING YOUR COMPANY…' : 'LOADING VENDOR…'}</span>
    <div style={{ width: 160, height: 2, background: isDark ? '#1f1f1f' : T.bdr, borderRadius: 2, overflow: 'hidden' }}>
      <div style={{ width: '60%', height: 2, background: T.blue, borderRadius: 2, animation: 'slide 1.2s ease-in-out infinite alternate' }} />
    </div>
  </div>
);

if (error || !vendor) return (
  <div style={{ fontFamily: sans, background: isDark ? '#000000' : T.bg, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <div style={{ textAlign: 'center', maxWidth: 360 }}>
      <div style={{ 
        fontSize: 13, 
        marginBottom: 12, 
        padding: '10px 16px', 
        background: isDark ? '#1a0a0a' : T.redBg, 
        border: `1px solid ${isDark ? '#DC262640' : T.redBdr}`, 
        borderRadius: 6, 
        color: T.red 
      }}>
        {error || 'Vendor not found.'}
      </div>
      <button onClick={() => navigate('/vendors')} style={topBtn(true, isDark)}>← Back to Vendors</button>
    </div>
  </div>
);

  const initials = vendor.name.split(' ').map((w: string) => w[0]).slice(0, 2).join('').toUpperCase();

  return (
    <div style={{ fontFamily: sans, background: isDark ? '#000000' : T.bg, minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>

      {/* ── Top header bar ───────────────────────────────────────── */}
      <div style={{ background: isDark ? '#0d0d0d' : T.surface, borderBottom: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 14, flexShrink: 0 }}>
        {!isSelf && (
        <button onClick={() => navigate('/vendors')} style={{ width: 34, height: 34, borderRadius: 7, border: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, background: isDark ? '#0d0d0d' : T.surface, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: isDark ? '#94a3b8' : T.slate, flexShrink: 0 }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        )}

        <div style={{ width: 40, height: 40, borderRadius: 10, background: T.blue, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, color: '#fff', flexShrink: 0, position: 'relative', overflow: 'hidden' }}>
          <img
            src={`https://www.google.com/s2/favicons?domain=${vendor.domain}&sz=40`}
            alt=""
            style={{ width: 40, height: 40, position: 'absolute', objectFit: 'contain' }}
            onError={e => { (e.target as HTMLImageElement).style.display = 'none'; }}
            onLoad={e => {
              const parent = (e.target as HTMLImageElement).parentElement;
              if (parent) { parent.style.background = 'transparent'; const t = parent.querySelector('span'); if (t) t.style.display = 'none'; }
            }}
          />
          <span style={{ position: 'relative', zIndex: 1 }}>{initials}</span>
        </div>

        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 2 }}>
            <span style={{ fontSize: 16, fontWeight: 700, color: isDark ? '#e2e8f0' : T.ink }}>{vendor.name}</span>
            {isSelf ? (
              <span style={{ display: 'inline-flex', padding: '2px 8px', borderRadius: 3, background: isDark ? '#0a1628' : T.blueBg, border: `1px solid ${isDark ? '#3B82F640' : T.blueBdr}`, fontSize: 9, fontWeight: 700, color: isDark ? '#60A5FA' : T.indigo, letterSpacing: '.05em', fontFamily: mono }}>
                YOUR COMPANY
              </span>
            ) : (vendor.status || 'active').toLowerCase() === 'cold' ? (
              <span style={{ display: 'inline-flex', padding: '2px 8px', borderRadius: 3, background: isDark ? '#1a1a1a' : T.surface2, border: `1px solid ${isDark ? '#333' : T.bdr}`, fontSize: 9, fontWeight: 700, color: isDark ? '#94a3b8' : T.slate, letterSpacing: '.05em', fontFamily: mono }}>
                INACTIVE
              </span>
            ) : (
              <span style={{ display: 'inline-flex', padding: '2px 8px', borderRadius: 3, background: isDark ? '#0a1a0a' : T.grnBg, border: `1px solid ${isDark ? '#15803D40' : T.grnBdr}`, fontSize: 9, fontWeight: 700, color: T.grn, letterSpacing: '.05em', fontFamily: mono }}>
                ACTIVE
              </span>
            )}
          </div>
          <div style={{ fontSize: 11, color: isDark ? '#94a3b8' : T.muted }}>
            {isSelf
              ? `${vendor.domain} · How your company looks to customers, partners and attackers`
              : <>{vendor.vendorId && `Vendor ID: ${vendor.vendorId}`}{vendor.category && ` · Category: ${vendor.category}`}</>}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 1 }}>
            <button style={{ fontSize: 11, color: isDark ? '#3B82F6' : T.blue, fontWeight: 500, background: 'none', border: 'none', cursor: 'pointer', fontFamily: sans, padding: 0 }}
              onClick={() => window.open(`https://${vendor.domain}`, '_blank', 'noopener')}>
              {isSelf ? 'Visit website →' : 'View vendor profile →'}
            </button>
            {/* Found automatically from a link on the vendor's own website (services/linkedin_lookup.py). */}
            {vendor.linkedinUrl && (
              <a href={vendor.linkedinUrl} target="_blank" rel="noopener noreferrer" title="Open their LinkedIn page"
                style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 11, color: isDark ? '#3B82F6' : T.blue, fontWeight: 500, fontFamily: sans, textDecoration: 'none' }}>
                <LinkedInIcon size={12} />LinkedIn ↗
              </a>
            )}
          </div>
        </div>

        <div style={{ display: 'flex', gap: 28, alignItems: 'flex-start', marginRight: 12 }}>
          {(isSelf ? [
            { label: 'Monitored Since', value: fmtShort(monitoredSince) },
            { label: 'Last Scan',       value: latestScan ? fmtShort(latestScan.completed_at || latestScan.created_at) : 'Not yet' },
            { label: 'Scans',           value: String(scans.length) },
          ] : [
            { label: 'Owner',          value: vendor.owner || '—' },
            { label: 'Business Owner', value: vendor.businessOwner || '—' },
            { label: 'Onboarded On',   value: vendor.onboardedAt ? fmtShort(vendor.onboardedAt) : fmtShort(vendor.createdAt) },
          ]).map(({ label, value }) => (
            <div key={label} style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 9, fontWeight: 700, color: isDark ? '#94a3b8' : T.muted, letterSpacing: '.08em', textTransform: 'uppercase', marginBottom: 3 }}>{label}</div>
              <div style={{ fontSize: 12, fontWeight: 600, color: isDark ? '#e2e8f0' : T.ink }}>{value}</div>
            </div>
          ))}
        </div>

        <div style={{ display: 'flex', gap: 6 }}>
          {canScan && <ScanTypeButton label={vendor.lastScan ? '⟳ Rescan' : '⊕ Scan now'} onPick={handleNewScan} busy={vendorScan.isPending} isDark={isDark} buttonStyle={topBtn(true, isDark)} />}
          {isSelf ? selfActions : (<>
          <VendorHeaderMenus vendor={vendor} isDark={isDark} role={authUser?.role} onOpenTab={setActiveTab} />
          </>)}
        </div>
      </div>

      {/* ── Sidebar + Body ────────────────────────────────────────── */}
      <div style={{ flex: 1, display: 'flex', minHeight: 0 }}>

      <aside style={{ width: 216, flexShrink: 0, background: isDark ? '#0d0d0d' : T.surface, borderRight: `1px solid ${isDark ? '#1f1f1f' : T.bdr}` }}>
        <nav style={{ position: 'sticky', top: 0, padding: '14px 10px', display: 'flex', flexDirection: 'column', gap: 2 }}>
          {([
            { id: 'overview',    label: 'Overview' },
            { id: 'profile',     label: 'Profile' },
            { id: 'schedule',    label: 'Schedule' },
            { id: 'domains',     label: 'Domains' },
            { id: 'ip-addresses', label: 'IP Addresses' },
            { id: 'security-profile', label: 'Security Profile' },
            { id: 'questionnaires', label: 'Questionnaires' },
            { id: 'fourth-parties', label: 'Fourth Parties' },
            { id: 'assessments', label: 'Assessments' },
            { id: 'documents',   label: 'Documents' },
            { id: 'contacts',    label: 'Contacts' },
            { id: 'access',      label: 'Access inventory' },
            { id: 'contracts',   label: 'Contracts' },
            { id: 'issues',      label: 'Issues' },
            { id: 'remediation', label: 'Remediation' },
            { id: 'history',     label: 'History' },
          ] as const).map(({ id, label }) => {
            const active = activeTab === id;
            const accent = isDark ? '#3B82F6' : T.blue;
            return (
              <div
                key={id}
                role="button"
                aria-current={active ? 'page' : undefined}
                // The Remediation tab always opens on its list, even if a request was open there before.
                onClick={() => (id === 'remediation' ? openRemediationRequest(null) : setActiveTab(id))}
                style={{
                  display: 'flex', alignItems: 'center', padding: '9px 14px', borderRadius: 7,
                  fontSize: 13, fontWeight: active ? 700 : 500,
                  color: active ? accent : (isDark ? '#94a3b8' : T.slate),
                  background: active ? (isDark ? '#0a1628' : T.blueBg) : 'transparent',
                  boxShadow: active ? `inset 3px 0 0 ${accent}` : 'none',
                  cursor: 'pointer', userSelect: 'none', transition: 'background .12s',
                }}
                onMouseEnter={e => { if (!active) (e.currentTarget as HTMLElement).style.background = isDark ? '#141414' : T.surface2; }}
                onMouseLeave={e => { if (!active) (e.currentTarget as HTMLElement).style.background = 'transparent'; }}
              >
                {label}
              </div>
            );
          })}
        </nav>
      </aside>

      {/* ── Body ──────────────────────────────────────────────────── */}
      {/* The window scrolls, not this box; on Profile, 'clip' instead of 'auto' so its sticky section nav works. */}
      <div style={{ flex: 1, minWidth: 0, ...(activeTab === 'profile' ? { overflowX: 'clip' } : { overflowY: 'auto' }), padding: '14px 20px', display: 'flex', flexDirection: 'column', gap: 12 }}>
        {activeTab === 'overview' && (
          <>
            <style>{`
              @media (max-width: 1100px) { .ov-hero, .ov-two { grid-template-columns: minmax(0,1fr) !important; } .ov-hero > div:first-child { border-right: none !important; } .ov-facts { grid-template-columns: repeat(2, minmax(0,1fr)) !important; } }
            `}</style>
            {/* ── 1 Rating + open risks ── */}
            {(() => {
              const muted = isDark ? '#94a3b8' : T.muted;
              const ink = isDark ? '#e2e8f0' : T.ink;
              const line2 = isDark ? '#161616' : '#F1F5F9';
              const accent = isDark ? '#60A5FA' : '#185FA5';
              const score = vendor.score;
              const hasScore = typeof score === 'number';
              const grade = (s: number) => (s >= 90 ? 'A' : s >= 80 ? 'B' : s >= 70 ? 'C' : s >= 60 ? 'D' : 'F');
              const ringColor = scoreColor(score ?? 0);
              const r = 50, circ = 2 * Math.PI * r, dash = hasScore ? (Math.max(0, Math.min(100, score as number)) / 100) * circ : 0;

              // Trend over the picked period (the window scrolls through the scans already loaded for this vendor).
              const days = { '3M': 92, '6M': 183, '12M': 366, All: Infinity }[trendRange];
              const cutoff = Date.now() - days * 86400000;
              const pts = [...scans].reverse()
                .map(s => ({ id: s.scan_id || s.id, date: s.completed_at || s.created_at, score: s.overall_score }))
                .filter(p => typeof p.score === 'number' && (days === Infinity || new Date(p.date).getTime() >= cutoff));
              const W = 420, H = 130, padL = 8, padR = 34, top = 14, bottom = 22;
              const vals = pts.map(p => p.score as number);
              const lo = Math.max(0, Math.floor((Math.min(...vals, 100) - 5) / 10) * 10);
              const hi = Math.min(100, Math.ceil((Math.max(...vals, 0) + 5) / 10) * 10);
              const px = (i: number) => (pts.length === 1 ? (W - padR + padL) / 2 : padL + (i * (W - padL - padR)) / (pts.length - 1));
              const py = (v: number) => top + ((hi - v) * (H - top - bottom)) / Math.max(hi - lo, 1);
              const monthLabel = (iso: string) => new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

              const others = (vendorListQuery.data || []).filter((v: any) => v.id !== vendorId && typeof v.score === 'number');
              const below = hasScore ? others.filter((v: any) => v.score < (score as number)).length : 0;
              const counts = posture?.counts;
              const remCount = Object.keys(inRemediation).length;
              const unassigned = posture?.glance?.remediation?.serious_unassigned ?? 0;
              const lastScanDate = latestScan ? (latestScan.completed_at || latestScan.created_at) : null;
              const sevRing: Array<[keyof NonNullable<typeof counts>, string, string]> = [
                ['critical', 'Critical', '#DC2626'], ['high', 'High', '#EA580C'], ['medium', 'Medium', '#D97706'], ['low', 'Low', '#CA8A04'],
              ];
              const rangeBtn = (k: typeof trendRange) => (
                <button key={k} onClick={() => setTrendRange(k)} aria-pressed={trendRange === k}
                  style={{ padding: '5px 10px', fontSize: 12, fontWeight: 600, fontFamily: sans, cursor: 'pointer', border: 'none',
                    borderRight: k !== 'All' ? `1px solid ${isDark ? '#1f1f1f' : T.bdr}` : 'none',
                    background: trendRange === k ? ink : 'transparent', color: trendRange === k ? (isDark ? '#0d0d0d' : '#fff') : muted }}>{k}</button>
              );
              const smallBtn: React.CSSProperties = { fontFamily: sans, fontSize: 12.5, fontWeight: 600, borderRadius: 8, padding: '6px 11px', cursor: 'pointer',
                border: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, background: isDark ? '#0d0d0d' : '#fff', color: ink, whiteSpace: 'nowrap' };

              return (
                <div className="ov-hero" style={{ ...card(isDark), padding: 0, display: 'grid', gridTemplateColumns: 'minmax(0,1.6fr) minmax(0,1fr)' }}>
                  <div style={{ padding: '18px 20px', borderRight: `1px solid ${line2}`, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <span style={{ fontSize: 13.5, fontWeight: 700, color: ink }}>Security rating</span>
                      <span style={{ marginLeft: 'auto', display: 'inline-flex', border: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, borderRadius: 8, overflow: 'hidden' }}>
                        {(['3M', '6M', '12M', 'All'] as const).map(rangeBtn)}
                      </span>
                    </div>
                    <div style={{ display: 'flex', gap: 22, alignItems: 'center', marginTop: 12, flexWrap: 'wrap' }}>
                      <svg width="128" height="128" viewBox="0 0 120 120" role="img" aria-label={hasScore ? `Security rating ${score} out of 100` : 'Not rated yet'} style={{ flexShrink: 0 }}>
                        <circle cx="60" cy="60" r={r} fill="none" stroke={isDark ? '#1f1f1f' : '#EEF2F7'} strokeWidth="11" />
                        {hasScore && <circle cx="60" cy="60" r={r} fill="none" stroke={ringColor} strokeWidth="11" strokeLinecap="round" strokeDasharray={`${dash} ${circ - dash}`} transform="rotate(-90 60 60)" />}
                        <text x="60" y="60" textAnchor="middle" fontSize="30" fontWeight="700" fill={ink} fontFamily={sans}>{hasScore ? score : '—'}</text>
                        <text x="60" y="79" textAnchor="middle" fontSize="11" fill={muted} fontFamily={sans}>out of 100</text>
                      </svg>
                      <div style={{ minWidth: 150 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                          <span style={{ fontSize: 24, fontWeight: 700, color: ink }}>{hasScore ? `Grade ${grade(score as number)}` : 'Not rated yet'}</span>
                          {vendor.riskLevel && hasScore && <RiskBadge level={vendor.riskLevel} isDark={isDark} />}
                        </div>
                        <div style={{ marginTop: 8, fontSize: 12.5, color: muted }}>
                          {prevScan
                            ? <><b style={{ color: scoreTrend > 0 ? '#16A34A' : scoreTrend < 0 ? '#DC2626' : muted }}>{scoreTrend > 0 ? `▲ ${scoreTrend}` : scoreTrend < 0 ? `▼ ${Math.abs(scoreTrend)}` : 'No change'}</b> since the previous scan ({prevScan.overall_score})</>
                            : hasScore ? 'First scan — nothing to compare yet' : 'Run a scan to rate this vendor'}
                        </div>
                        {hasScore && others.length > 0 && (
                          <div style={{ marginTop: 4, fontSize: 12, color: muted }}>
                            Higher than {below} of your {others.length} {isSelf ? 'vendors' : 'other vendors'}
                          </div>
                        )}
                      </div>
                      <div style={{ flex: 1, minWidth: 220 }}>
                        {pts.length >= 2 ? (
                          <svg viewBox={`0 0 ${W} ${H}`} width="100%" height={H} role="img" aria-label={`Rating over ${trendRange}: ${vals.join(', ')}`} style={{ display: 'block' }}>
                            {[lo, (lo + hi) / 2, hi].map(v => (
                              <g key={v}>
                                <line x1={padL} x2={W - padR} y1={py(v)} y2={py(v)} stroke={line2} />
                                <text x={W - 4} y={py(v) + 3} textAnchor="end" fontSize="10" fill={muted} fontFamily={sans}>{Math.round(v)}</text>
                              </g>
                            ))}
                            <polyline fill="none" stroke={accent} strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round"
                              points={pts.map((p, i) => `${px(i)},${py(p.score as number)}`).join(' ')} />
                            {pts.map((p, i) => (
                              <circle key={p.id || i} cx={px(i)} cy={py(p.score as number)} r={i === pts.length - 1 ? 4.5 : 3} fill={accent}
                                style={{ cursor: 'pointer' }} onClick={() => p.id && handleViewScan(p.id)}>
                                <title>{`${fmtShort(p.date)}: ${p.score}`}</title>
                              </circle>
                            ))}
                            <text x={padL} y={H - 5} fontSize="10" fill={muted} fontFamily={sans}>{monthLabel(pts[0].date)}</text>
                            <text x={W - padR} y={H - 5} textAnchor="end" fontSize="10" fill={muted} fontFamily={sans}>{monthLabel(pts[pts.length - 1].date)}</text>
                          </svg>
                        ) : (
                          <div style={{ fontSize: 12, color: muted, textAlign: 'center', padding: '30px 0' }}>
                            {scans.length >= 2 ? `Only ${pts.length} scan in this period — pick a longer range.` : 'The trend appears after the second scan.'}
                          </div>
                        )}
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap', alignItems: 'center', marginTop: 14, paddingTop: 12, borderTop: `1px solid ${line2}`, fontSize: 12, color: muted }}>
                      <span>Last scan <b style={{ color: ink }}>{lastScanDate ? fmtShort(lastScanDate) : 'Never'}</b>
                        {posture?.scan_id && <> · <button style={{ ...linkBtn(isDark), fontSize: 12 }} onClick={() => handleViewScan(posture.scan_id as string)}>Open report</button></>}
                      </span>
                      <button onClick={() => setActiveTab('schedule')} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontFamily: sans, fontSize: 12, color: muted }}>
                        {posture?.glance?.next_scan_at ? <>Next scan <b style={{ color: ink }}>{fmtShort(posture.glance.next_scan_at)}</b></> : <span style={{ color: accent }}>No scan scheduled →</span>}
                      </button>
                      {monitoredSince && <span>Monitored since <b style={{ color: ink }}>{fmtShort(monitoredSince)}</b> · {scanTotal} scan{scanTotal === 1 ? '' : 's'}</span>}
                      <span style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
                        {lastChange && <button style={smallBtn} onClick={openComparison}>Compare scans</button>}
                        {canScan && <ScanTypeButton label={vendor.lastScan ? '⟳ Rescan' : '⊕ Scan now'} onPick={handleNewScan} busy={vendorScan.isPending} isDark={isDark}
                          buttonStyle={{ ...smallBtn, background: '#185FA5', borderColor: '#185FA5', color: '#fff' }} />}
                      </span>
                    </div>
                  </div>

                  <div style={{ padding: '18px 20px', minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <span style={{ fontSize: 13.5, fontWeight: 700, color: ink }}>Open risks by severity</span>
                      <button style={{ ...linkBtn(isDark), marginLeft: 'auto' }} onClick={() => setActiveTab('issues')}>View issues</button>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 6, marginTop: 16, textAlign: 'center' }}>
                      {sevRing.map(([key, label, col]) => (
                        <button key={key} onClick={() => setActiveTab('issues')} title={`Open ${label.toLowerCase()} issues`}
                          style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontFamily: sans }}>
                          <span style={{ width: 52, height: 52, margin: '0 auto', borderRadius: '50%', border: `3px solid ${col}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 19, fontWeight: 700, color: col }}>
                            {counts ? counts[key] : '—'}
                          </span>
                          <span style={{ display: 'block', marginTop: 6, fontSize: 12.5, fontWeight: 600, color: ink }}>{label}</span>
                        </button>
                      ))}
                    </div>
                    <div style={{ marginTop: 16, display: 'grid', gap: 8, fontSize: 12.5, color: ink }}>
                      {lastChange ? (
                        <>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}><span style={{ width: 7, height: 7, borderRadius: '50%', background: accent }} />
                            {lastChange.new_findings.length} new since the last scan</div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}><span style={{ width: 7, height: 7, borderRadius: '50%', background: '#16A34A' }} />
                            {lastChange.resolved.length} fixed since the last scan</div>
                        </>
                      ) : (
                        <div style={{ color: muted }}>{hasScore ? 'Changes since the last scan show after the second scan.' : ''}</div>
                      )}
                      {!isSelf && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}><span style={{ width: 7, height: 7, borderRadius: '50%', background: '#7C3AED' }} />
                          <span>{remCount} in remediation{unassigned > 0 && <> · <b style={{ color: '#DC2626' }}>{unassigned} critical/high not assigned yet</b></>}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })()}

            {/* ── 2 About the company + Scan history ── */}
            <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)', gap: 12 }}>

              {/* ── About the company ── */}
              {(() => {
                const muted = isDark ? '#94a3b8' : T.muted;
                const ink = isDark ? '#e2e8f0' : T.ink;
                const info = posture?.vendor;
                const accent = isDark ? '#3B82F6' : T.blue;
                const ago = (iso: string | null) => {
                  if (!iso) return '';
                  const minutes = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
                  return minutes < 1 ? 'just now' : minutes < 60 ? `${minutes} min ago` : minutes < 1440 ? `${Math.round(minutes / 60)} h ago` : `${Math.round(minutes / 1440)} d ago`;
                };
                const daysLeft = posture?.glance?.contract_days_left;
                const contractChip = daysLeft == null ? null
                  : <Tone name={daysLeft < 0 ? 'red' : daysLeft <= 90 ? 'amber' : 'green'} isDark={isDark}>{daysLeft < 0 ? `ended ${-daysLeft} days ago` : `in ${daysLeft} days`}</Tone>;

                // Employees and revenue come from the company research's structured facts; contract value from the vendor
                // record. These three are always listed -- a missing one says so rather than leaving a gap.
                const missing = (text: string) => <span style={{ color: muted, fontWeight: 500 }}>{text}</span>;
                const money = (n: number) => n >= 1e6 ? `$${(n / 1e6).toFixed(n >= 1e7 ? 0 : 1)}M` : n >= 1e3 ? `$${Math.round(n / 1e3)}K` : `$${Math.round(n)}`;
                const rf = companyProfile?.facts || {};
                const found = (v?: string | null) => v || missing(companyProfileLoading ? 'Looking…' : 'Not found');
                const employees = rf.employees?.value?.replace(/^estimated\s+/i, '');
                const revenue = rf.annual_revenue?.value;
                const incorporated = rf.incorporated?.value ? fmtShort(rf.incorporated.value) : null;
                const facts: { label: string; value: React.ReactNode }[] = [
                  { label: 'Category',       value: info?.category },
                  { label: 'Business unit',  value: info?.business_units?.length ? info.business_units.join(', ') : null },
                  { label: 'Industry',       value: found(rf.industry?.value || rf.industry_label?.value) },
                  { label: 'Headquarters',   value: found(rf.headquarters?.value || info?.location || rf.address?.value) },
                  { label: 'Other address',  value: rf.address?.value && rf.address.value !== (rf.headquarters?.value || info?.location) ? rf.address.value : null },
                  { label: 'Founded',        value: rf.founded?.value },
                  { label: 'Incorporated',   value: found(incorporated) },
                  { label: 'Legal entity',   value: rf.registered_legal_entity?.value },
                  { label: 'Parent company', value: info?.parent_company || rf.parent_organization?.value },
                  { label: 'Ownership',      value: rf.ownership?.value },
                  { label: 'Stock listing',  value: rf.listing?.value?.replace(/^publicly traded\s*/i, 'Public ') },
                  { label: 'Employees',      value: found(employees) },
                  { label: 'Estimated revenue', value: revenue || missing(companyProfileLoading ? 'Looking…' : 'Not public') },
                  { label: 'Contract value', value: info?.contract_value != null ? money(info.contract_value) : missing('Not set') },
                  { label: 'Website',        value: vendor.domain ? <a href={`https://${vendor.domain}`} target="_blank" rel="noreferrer" style={{ color: accent, textDecoration: 'none' }}>{vendor.domain} ↗</a> : null },
                  { label: 'Vendor since',   value: info?.vendor_since ? fmtShort(info.vendor_since) : null },
                  { label: 'Contract ends',  value: info?.contract_end_date
                      ? <span style={{ display: 'inline-flex', flexWrap: 'wrap', alignItems: 'center', gap: 6 }}>{fmtShort(info.contract_end_date)}{info.auto_renew ? ' (auto-renews)' : ''} {contractChip}</span>
                      : null },
                ].filter(f => f.value);

                const about = isSelf
                  ? `This is your own organisation, ${vendor.name} (${vendor.domain}). It has been monitored on FluxWatch since ${fmtShort(monitoredSince)} across ${scanTotal} scan${scanTotal === 1 ? '' : 's'}, using the same checks as your vendors.`
                  : `${vendor.name} is ${info?.category ? `a ${info.category} vendor` : 'a third-party vendor'}${info?.business_units?.length ? ` supporting ${info.business_units.join(', ')}` : ''}${info?.location ? `, based in ${info.location}` : ''}. It has been monitored on FluxWatch since ${fmtShort(monitoredSince)} across ${scanTotal} scan${scanTotal === 1 ? '' : 's'}.`;

                return (
                  <div style={card(isDark)}>
                    <div style={sectionHdr}>
                      <span style={sectionTitle(isDark)}>{isSelf ? 'About your company' : 'About the company'}</span>
                    </div>
                    {companyProfile?.summary ? (
                      <div style={{ marginBottom: 12 }}>
                        <div style={{ fontSize: 13, lineHeight: 1.6, color: ink, marginBottom: 8 }}>{companyProfile.summary}</div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '4px 8px', fontSize: 11, color: muted }}>
                          <span>Updated {ago(companyProfile.generated_at)}</span>
                          <button onClick={() => fetchCompanyProfile(true)} disabled={companyProfileLoading}
                            style={{ background: 'none', border: 'none', padding: 0, fontFamily: sans, fontSize: 11, fontWeight: 600, color: accent, cursor: companyProfileLoading ? 'default' : 'pointer', opacity: companyProfileLoading ? 0.6 : 1 }}>
                            {companyProfileLoading ? 'Refreshing…' : 'Refresh'}
                          </button>
                        </div>
                        {companyProfile.stale && (
                          <div style={{ fontSize: 11, color: T.amb, marginTop: 6 }}>
                            Live sources could not be reached, so this is the last successful profile ({ago(companyProfile.generated_at)}).
                          </div>
                        )}
                      </div>
                    ) : companyProfileLoading ? (
                      <div style={{ marginBottom: 12 }}>
                        <style>{'@keyframes fwpulse{0%,100%{opacity:.35}50%{opacity:.8}}'}</style>
                        {[100, 96, 62].map(width => (
                          <div key={width} style={{ height: 10, width: `${width}%`, borderRadius: 4, background: isDark ? '#1f1f1f' : T.surface2, marginBottom: 8, animation: 'fwpulse 1.4s ease-in-out infinite' }} />
                        ))}
                        <div style={{ fontSize: 11, color: muted }}>Researching {vendor.name} from public sources…</div>
                      </div>
                    ) : (
                      <div style={{ fontSize: 13, lineHeight: 1.6, color: ink, marginBottom: 12 }}>{about}</div>
                    )}
                    {facts.length > 0 && (
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px 16px' }}>
                        {facts.map(f => (
                          <div key={f.label}>
                            <div style={{ fontSize: 10, color: muted, letterSpacing: '.06em', textTransform: 'uppercase', marginBottom: 2 }}>{f.label}</div>
                            <div style={{ fontSize: 13, fontWeight: 600, color: ink }}>{f.value}</div>
                          </div>
                        ))}
                      </div>
                    )}

                  </div>
                );
              })()}

              {/* ── Scan History ── */}
              {(() => {
                const muted = isDark ? '#94a3b8' : T.muted;
                const ink = isDark ? '#e2e8f0' : T.ink;
                const line = isDark ? '#1f1f1f' : T.bdr;
                // Prefer the server's list (it knows who started each scan); fall back to the scans already loaded.
                const rows = posture?.scans?.recent?.length
                  ? posture.scans.recent
                  : scans.slice(0, 6).map(s => ({
                      id: s.scan_id || s.id, date: s.completed_at || s.created_at, scan_type: s.scan_type, score: s.overall_score,
                      risk_level: s.risk_level, trigger_source: null as string | null, triggered_by_name: null as string | null,
                    }));
                const startedBy = (r: { trigger_source: string | null; triggered_by_name: string | null }) =>
                  r.trigger_source === 'scheduled' ? <Tone name="purple" isDark={isDark}>Schedule</Tone>
                    : r.triggered_by_name ? <Tone name="blue" isDark={isDark}>{r.triggered_by_name}</Tone>
                    : r.trigger_source === 'onboarding' ? <Tone name="green" isDark={isDark}>Onboarding</Tone>
                    : <span style={{ fontSize: 11, color: muted }}>—</span>;
                return (
                  <div style={card(isDark)}>
                    <div style={sectionHdr}>
                      <span style={sectionTitle(isDark)}>Scan history</span>
                      <button style={linkBtn(isDark)} onClick={() => setActiveTab('history')}>View all</button>
                    </div>
                    {rows.length === 0 ? (
                      <div style={{ textAlign: 'center', padding: '32px 0' }}>
                        <div style={{ fontSize: 13, fontWeight: 600, color: isDark ? '#94a3b8' : T.slate, marginBottom: 4 }}>No scans yet</div>
                        <div style={{ fontSize: 11, color: muted }}>Use Scan now to start the first assessment.</div>
                      </div>
                    ) : (
                      <div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1.3fr 1.1fr .6fr 1fr auto', gap: 8, fontSize: 10, color: muted, letterSpacing: '.06em', textTransform: 'uppercase', padding: '0 0 6px' }}>
                          <span>Date</span><span>Started by</span><span>Type</span><span>Score</span><span />
                        </div>
                        {rows.map(r => {
                          const dt = fmtDate(r.date || '');
                          return (
                            <div key={r.id} style={{ display: 'grid', gridTemplateColumns: '1.3fr 1.1fr .6fr 1fr auto', gap: 8, alignItems: 'center', padding: '8px 0', borderTop: `1px solid ${line}` }}>
                              <span><span style={{ display: 'block', fontSize: 12, fontWeight: 600, color: ink }}>{dt.date}</span><span style={{ fontSize: 10.5, color: muted }}>{dt.time}</span></span>
                              <span style={{ minWidth: 0, overflow: 'hidden' }}>{startedBy(r)}</span>
                              <span style={{ fontSize: 12, color: isDark ? '#94a3b8' : T.slate, textTransform: 'capitalize' }}>{r.scan_type || '—'}</span>
                              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                                <span style={{ fontSize: 14, fontWeight: 700, color: scoreColor(r.score ?? 0), fontFamily: mono }}>{r.score ?? '—'}</span>
                                {r.risk_level && <RiskBadge level={r.risk_level} isDark={isDark} />}
                              </span>
                              <button onClick={() => handleViewScan(r.id)}
                                style={{ padding: '4px 8px', whiteSpace: 'nowrap', borderRadius: 5, fontSize: 11, fontWeight: 500, border: `1px solid ${line}`, background: isDark ? '#0d0d0d' : T.surface, color: ink, cursor: 'pointer', fontFamily: sans }}>
                                View ↗
                              </button>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              })()}

            </div>{/* end About the company / Scan history row */}


            {/* ── 3 Needs your attention ── */}
            {(() => {
              const muted = isDark ? '#94a3b8' : T.muted;
              const ink = isDark ? '#e2e8f0' : T.ink;
              const line2 = isDark ? '#161616' : '#F1F5F9';
              type Item = { sev: 'High' | 'Medium' | 'Low'; title: string; sub?: string; label: string; go: () => void };
              const items: Item[] = [];
              const g = posture?.glance;
              const plural = (n: number, one: string, many: string) => (n === 1 ? one : many);

              const unassigned = g?.remediation?.serious_unassigned ?? 0;
              if (!isSelf && unassigned > 0) {
                const names = (posture?.top_findings || []).filter(f => (f.severity === 'Critical' || f.severity === 'High') && !inRemediation[f.name]).map(f => f.name);
                items.push({ sev: 'High', title: `${unassigned} critical or high ${plural(unassigned, "risk isn't", "risks aren't")} in a remediation request`,
                  sub: names.slice(0, 3).join(', ') || undefined, label: 'Request remediation', go: () => setActiveTab('issues') });
              }
              if (!latestScan) {
                items.push({ sev: 'High', title: isSelf ? 'Your company has never been scanned' : 'This vendor has never been scanned', sub: 'Run a scan to rate it and find its risks.',
                  label: canScan ? 'Scan now' : 'Open schedule', go: () => (canScan ? handleNewScan('fast') : setActiveTab('schedule')) });
              } else {
                const age = Math.floor((Date.now() - new Date(latestScan.completed_at || latestScan.created_at).getTime()) / 86400000);
                if (age > 30) {
                  items.push({ sev: 'Medium', title: `Last scanned ${age} days ago`, sub: g?.next_scan_at ? `Next scan ${fmtShort(g.next_scan_at)}` : 'No scan is scheduled',
                    label: canScan ? 'Scan now' : 'Open schedule', go: () => (canScan ? handleNewScan('fast') : setActiveTab('schedule')) });
                }
              }
              if (prevScan && scoreTrend <= -5) {
                const worst = (lastChange?.categories || []).filter(c => (c.change ?? 0) < 0).sort((a, b) => (a.change ?? 0) - (b.change ?? 0))[0];
                items.push({ sev: scoreTrend <= -10 ? 'High' : 'Medium', title: `Rating dropped ${Math.abs(scoreTrend)} points on the last scan`,
                  sub: worst ? `Biggest change: ${worst.name} ${Math.round(worst.from ?? 0)} → ${Math.round(worst.to ?? 0)}` : undefined,
                  label: 'See what changed', go: openComparison });
              }
              const days = g?.contract_days_left;
              if (!isSelf && days != null) {
                const end = posture?.vendor?.contract_end_date ? fmtShort(posture.vendor.contract_end_date) : '';
                if (days < 0) items.push({ sev: 'High', title: `Contract ended ${-days} days ago`, sub: end, label: 'Open contracts', go: () => setActiveTab('contracts') });
                else if (days <= 60) items.push({ sev: 'Medium', title: `Contract ${posture?.vendor?.auto_renew ? 'renews' : 'ends'} in ${days} days`,
                  sub: `${end}${posture?.vendor?.auto_renew ? ' · auto-renews' : ''}`, label: 'Open contracts', go: () => setActiveTab('contracts') });
              }
              const awaiting = g?.remediation?.awaiting_review ?? 0;
              if (!isSelf && awaiting > 0) {
                items.push({ sev: 'Medium', title: `${awaiting} remediation ${plural(awaiting, 'request is', 'requests are')} waiting for your review`,
                  label: 'Review', go: () => openRemediationRequest(null) });
              }
              const q = g?.questionnaire;
              if (!isSelf && q?.due_date && new Date(q.due_date).getTime() < Date.now() && !['answered', 'reviewed'].includes(q.status)) {
                items.push({ sev: 'Medium', title: `The ${q.name} questionnaire is overdue`, sub: `Due ${fmtShort(q.due_date)} · ${q.answered} of ${q.total} answered`,
                  label: 'Open questionnaires', go: () => setActiveTab('questionnaires') });
              }
              if (!isSelf && g?.inherent_risk && !g.inherent_risk.tier) {
                items.push({ sev: 'Low', title: "Inherent risk isn't classified", sub: 'Set data sensitivity and business criticality so the risk tier and financial exposure are accurate.',
                  label: 'Classify', go: () => setActiveTab('profile') });
              }
              const rank = { High: 0, Medium: 1, Low: 2 };
              items.sort((a, b) => rank[a.sev] - rank[b.sev]);
              const tone: Record<Item['sev'], ToneName> = { High: 'red', Medium: 'amber', Low: 'slate' };

              return (
                <div style={{ ...card(isDark), padding: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '14px 18px', borderBottom: items.length ? `1px solid ${line2}` : 'none', flexWrap: 'wrap' }}>
                    <span style={{ fontSize: 13.5, fontWeight: 700, color: ink }}>Needs your attention</span>
                    {items.length > 0 && <Tone name={items[0].sev === 'High' ? 'red' : 'amber'} isDark={isDark}>{items.length}</Tone>}
                    <span style={{ fontSize: 12, color: muted }}>{items.length ? `What to do next for ${isSelf ? 'your company' : 'this vendor'}, most important first` : 'Nothing needs attention right now.'}</span>
                  </div>
                  {items.map((it, i) => (
                    <div key={it.title} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '11px 18px', borderTop: i ? `1px solid ${line2}` : 'none', flexWrap: 'wrap' }}>
                      <span style={{ minWidth: 64, display: 'inline-flex', justifyContent: 'center' }}><Tone name={tone[it.sev]} isDark={isDark}>{it.sev}</Tone></span>
                      <div style={{ flex: 1, minWidth: 200 }}>
                        <div style={{ fontSize: 13, fontWeight: 600, color: ink }}>{it.title}</div>
                        {it.sub && <div style={{ fontSize: 12, color: muted, marginTop: 2 }}>{it.sub}</div>}
                      </div>
                      <button onClick={it.go} style={{ fontFamily: sans, fontSize: 12.5, fontWeight: 600, borderRadius: 8, padding: '6px 11px', cursor: 'pointer', whiteSpace: 'nowrap',
                        ...(i === 0 && it.sev === 'High' ? { background: '#185FA5', border: '1px solid #185FA5', color: '#fff' }
                          : { background: isDark ? '#0d0d0d' : '#fff', border: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, color: ink }) }}>
                        {it.label}
                      </button>
                    </div>
                  ))}
                </div>
              );
            })()}

            {/* ── 4 Key facts (each opens its tab) ── */}
            {posture?.glance && (() => {
              const g = posture.glance;
              const muted = isDark ? '#94a3b8' : T.muted;
              const ink = isDark ? '#e2e8f0' : T.ink;
              const line2 = isDark ? '#161616' : '#F1F5F9';
              const tierTone: Record<string, ToneName> = { Critical: 'red', High: 'amber', Medium: 'blue', Low: 'green' };
              const money = (n: number) => n >= 1e6 ? `$${(n / 1e6).toFixed(n >= 1e7 ? 0 : 1)}M` : n >= 1e3 ? `$${Math.round(n / 1e3).toLocaleString()}K` : `$${Math.round(n)}`;
              const ir = g.inherent_risk, rem = g.remediation, fp = g.fourth_parties, q = g.questionnaire;
              const info = posture.vendor;
              const tiles: { label: string; tab: VendorTab; body: React.ReactNode; sub: React.ReactNode }[] = [
                { label: 'Inherent risk', tab: 'profile',
                  body: ir?.tier ? <Tone name={tierTone[ir.tier] || 'slate'} isDark={isDark}>{ir.tier}</Tone> : <Tone name="amber" isDark={isDark}>Not classified</Tone>,
                  sub: ir?.tier ? ir.drivers.map(d => d.replace(/_/g, ' ')).join(' · ') : 'Classify it on the Profile tab' },
                { label: 'Remediation', tab: 'remediation',
                  body: <span style={{ fontSize: 20, fontWeight: 700, color: ink }}>{rem?.open ?? 0} open</span>,
                  sub: rem?.awaiting_review ? <span style={{ color: T.amb }}>{rem.awaiting_review} awaiting your review</span>
                    : rem?.serious_unassigned ? <span style={{ color: isDark ? '#F87171' : T.red }}>{rem.serious_unassigned} critical/high not in a request</span> : 'Nothing waiting' },
                { label: 'Questionnaire', tab: 'questionnaires',
                  body: q ? <Tone name={q.status === 'answered' || q.status === 'reviewed' ? 'green' : 'blue'} isDark={isDark}>{q.status === 'answered' || q.status === 'reviewed' ? 'Answered' : `In progress · ${q.percent}%`}</Tone>
                    : <Tone name="slate" isDark={isDark}>None sent</Tone>,
                  sub: q ? `${q.name}${q.due_date ? ` · due ${fmtShort(q.due_date)}` : ''}` : 'Send one from the Questionnaires tab' },
                { label: 'Fourth parties', tab: 'fourth-parties',
                  body: <span style={{ fontSize: 20, fontWeight: 700, color: ink }}>{fp?.companies ?? 0}</span>,
                  sub: fp?.shared ? `${fp.shared} shared with your other vendors` : 'None shared with other vendors' },
                ...(isSelf ? [] : [{ label: 'Contract', tab: 'contracts' as VendorTab,
                  body: <span style={{ fontSize: 20, fontWeight: 700, color: info?.contract_value != null ? ink : muted }}>{info?.contract_value != null ? money(info.contract_value) : 'Not set'}</span>,
                  sub: info?.contract_end_date ? `${info.auto_renew ? 'Renews' : 'Ends'} ${fmtShort(info.contract_end_date)}` : 'No end date recorded' }]),
              ];
              return (
                <div className="ov-facts" style={{ ...card(isDark), padding: 0, display: 'grid', gridTemplateColumns: `repeat(${tiles.length}, minmax(0, 1fr))` }}>
                  {tiles.map((t, i) => (
                    <button key={t.label} onClick={() => setActiveTab(t.tab)}
                      style={{ textAlign: 'left', background: 'none', border: 'none', borderRight: i < tiles.length - 1 ? `1px solid ${line2}` : 'none', padding: '14px 18px',
                        cursor: 'pointer', fontFamily: sans, display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0 }}>
                      <span style={{ fontSize: 12, color: muted }}>{t.label}</span>
                      <span style={{ minHeight: 26, display: 'flex', alignItems: 'center' }}>{t.body}</span>
                      <span style={{ fontSize: 11.5, color: muted, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>{t.sub}</span>
                    </button>
                  ))}
                </div>
              );
            })()}

            {/* ── 5 Security posture: score by category | top findings ── */}
            {(() => {
              const muted = isDark ? '#94a3b8' : T.muted;
              const ink = isDark ? '#e2e8f0' : T.ink;
              const line2 = isDark ? '#161616' : '#F1F5F9';
              const hdr = (title: string, sub: string, action?: React.ReactNode) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '14px 18px', borderBottom: `1px solid ${line2}` }}>
                  <span style={{ fontSize: 13.5, fontWeight: 700, color: ink }}>{title}</span>
                  <span style={{ fontSize: 12, color: muted }}>{sub}</span>
                  <span style={{ marginLeft: 'auto' }}>{action}</span>
                </div>
              );
              if (!posture || !posture.has_scan) {
                return (
                  <div style={card(isDark)}>
                    <div style={sectionHdr}><span style={sectionTitle(isDark)}>Security posture</span></div>
                    <div style={{ fontSize: 12, color: muted }}>{!posture ? 'Loading…' : isSelf ? 'Run a scan to see your security posture.' : "Run a scan to see this vendor's security posture."}</div>
                  </div>
                );
              }
              const changeOf = Object.fromEntries((lastChange?.categories || []).map(c => [c.name, c.change]));
              const categories = Object.entries(posture.category_scores || {}).sort((a, b) => a[1] - b[1]);
              const shownCats = catShowAll ? categories : categories.slice(0, 5);
              const newNames = new Set((lastChange?.new_findings || []).map(f => f.indicator_name));
              const worseNames = new Set((lastChange?.declined || []).map(f => f.indicator_name));
              const sevTone: Record<string, ToneName> = { Critical: 'red', High: 'red', Medium: 'amber', Low: 'slate' };
              const proj = fixPreviewQuery.data?.projected_score;
              const cur = fixPreviewQuery.data?.current_score ?? posture.score;
              const tag = (text: string, name: ToneName) => <span style={{ marginLeft: 6, display: 'inline-flex' }}><Tone name={name} isDark={isDark}>{text}</Tone></span>;
              return (
                <div className="ov-two" style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1fr) minmax(0,1.2fr)', gap: 12 }}>
                  <div style={{ ...card(isDark), padding: 0 }}>
                    {hdr('Score by category', 'weakest first', <button style={linkBtn(isDark)} onClick={() => setActiveTab('security-profile')}>Security profile</button>)}
                    <div style={{ padding: '12px 18px', display: 'grid', gap: 11 }}>
                      {shownCats.length === 0 && <div style={{ fontSize: 12, color: muted }}>No category scores on this scan.</div>}
                      {shownCats.map(([cat, sc]) => {
                        const ch = changeOf[cat];
                        return (
                          <div key={cat}>
                            <div style={{ display: 'flex', alignItems: 'baseline', fontSize: 12.5, color: ink }}>
                              <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{cat}</span>
                              <b style={{ marginLeft: 'auto', color: scoreColor(sc), fontFamily: mono }}>{Math.round(sc)}</b>
                              <span style={{ width: 40, textAlign: 'right', fontSize: 11.5, color: ch == null || Math.abs(ch) < 0.5 ? muted : ch > 0 ? '#16A34A' : '#DC2626' }}>
                                {ch == null || Math.abs(ch) < 0.5 ? '—' : `${ch > 0 ? '▲' : '▼'}${Math.round(Math.abs(ch))}`}
                              </span>
                            </div>
                            <div style={{ height: 6, borderRadius: 99, background: isDark ? '#1a1a1a' : T.surface2, overflow: 'hidden', marginTop: 5 }}>
                              <div style={{ height: 6, width: `${Math.max(2, sc)}%`, borderRadius: 99, background: scoreColor(sc) }} />
                            </div>
                          </div>
                        );
                      })}
                      {categories.length > 5 && (
                        <button style={{ ...linkBtn(isDark), justifySelf: 'start' }} onClick={() => setCatShowAll(v => !v)}>
                          {catShowAll ? 'Show fewer' : `Show all ${categories.length} categories`}
                        </button>
                      )}
                    </div>
                  </div>

                  <div style={{ ...card(isDark), padding: 0, display: 'flex', flexDirection: 'column' }}>
                    {hdr('Top findings', 'fix these first', <button style={linkBtn(isDark)} onClick={() => setActiveTab('issues')}>All issues</button>)}
                    {posture.top_findings.length === 0 ? (
                      <div style={{ padding: '24px 18px', fontSize: 12.5, color: muted }}>No open findings on the latest scan.</div>
                    ) : posture.top_findings.map((f, i) => {
                      const gain = f.score_gain_if_fixed;
                      return (
                        <div key={f.name} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 18px', borderTop: i ? `1px solid ${line2}` : 'none' }}>
                          <span style={{ minWidth: 60, display: 'inline-flex' }}><Tone name={sevTone[f.severity] || 'slate'} isDark={isDark}>{f.severity}</Tone></span>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: 13, fontWeight: 600, color: ink, display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                              <span>{f.name}</span>
                              {newNames.has(f.name) && tag('NEW', 'blue')}
                              {worseNames.has(f.name) && tag('▲ worse', 'red')}
                              {!isSelf && inRemediation[f.name] && tag('In remediation', 'purple')}
                            </div>
                            {f.category && <div style={{ fontSize: 11.5, color: muted, marginTop: 1 }}>{f.category}</div>}
                          </div>
                          {gain != null && <Tone name={gain >= 1 ? 'blue' : 'slate'} isDark={isDark}>{gain >= 0.1 ? `+${gain.toFixed(1)} pts` : '<0.1 pts'}</Tone>}
                        </div>
                      );
                    })}
                    {proj != null && cur != null && proj > cur && seriousNames.length > 0 && (
                      <div style={{ marginTop: 'auto', display: 'flex', alignItems: 'center', gap: 10, padding: '11px 18px', borderTop: `1px solid ${line2}`, background: isDark ? '#111' : '#FBFCFE', borderRadius: '0 0 10px 10px' }}>
                        <span style={{ fontSize: 12, color: muted }}>Fixing {seriousNames.length === 1 ? 'this critical/high risk' : `these ${seriousNames.length} critical/high risks`} would raise the rating to about</span>
                        <b style={{ marginLeft: 'auto', fontSize: 15, color: scoreColor(proj), fontFamily: mono }}>{proj}</b>
                      </div>
                    )}
                  </div>
                </div>
              );
            })()}

            {/* ── 6 Estimated Financial Exposure ── */}
            {exposure && !exposure.available && (() => {
              const muted = isDark ? '#94a3b8' : T.muted;
              const ink = isDark ? '#e2e8f0' : T.ink;
              const row = (ok: boolean, label: string) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{
                    width: 16, height: 16, borderRadius: 99, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 10, fontWeight: 800, color: '#fff',
                    background: ok ? (isDark ? '#16A34A' : '#16A34A') : (isDark ? '#475569' : '#CBD5E1'),
                  }}>{ok ? '✓' : '—'}</span>
                  <span style={{ fontSize: 13, color: ok ? ink : muted }}>{label}</span>
                </div>
              );
              return (
                <div style={card(isDark)}>
                  <div style={sectionHdr}>
                    <span style={sectionTitle(isDark)}>Estimated financial exposure</span>
                    <Tone name="slate" isDark={isDark}>Not enough data yet</Tone>
                  </div>
                  <div style={{ fontSize: 12.5, color: ink, marginBottom: 12 }}>{exposure.reason}</div>
                  <div style={{ display: 'grid', gap: 7, marginBottom: 4 }}>
                    {row(exposure.has_scan, 'A completed scan')}
                    {row(exposure.has_questionnaire, 'A submitted questionnaire response (sent alone isn’t enough)')}
                  </div>
                  <div style={{ fontSize: 10.5, color: muted, lineHeight: 1.5, marginTop: 12 }}>
                    This vendor is also left out of the portfolio's total and average exposure on the Dashboard until both are available.
                  </div>
                </div>
              );
            })()}
            {exposure && exposure.available && (() => {
              const muted = isDark ? '#94a3b8' : T.muted;
              const ink = isDark ? '#e2e8f0' : T.ink;
              const dbir = exposure.dbir_context;
              const points: [string, ToneName, number][] = [
                ['Minimum', 'green', exposure.exposure_range.minimum],
                ['Most likely', 'blue', exposure.exposure_range.likely],
                ['Maximum', 'red', exposure.exposure_range.maximum],
              ];
              return (
                <div style={card(isDark)}>
                  <div style={sectionHdr}>
                    <span style={sectionTitle(isDark)}>Estimated financial exposure</span>
                    <Tone name="slate" isDark={isDark}>Estimate · not a valuation</Tone>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 10, marginBottom: 12 }}>
                    {points.map(([label, name, value]) => {
                      const [bg, fg, bdr] = toneOf(name, isDark);
                      return (
                        <div key={label} style={{ padding: '10px 14px', borderRadius: 8, background: bg, border: `1px solid ${bdr}` }}>
                          <div style={{ fontSize: 10.5, fontWeight: 700, letterSpacing: '.05em', textTransform: 'uppercase', color: fg, opacity: 0.85, marginBottom: 2 }}>{label}</div>
                          <div style={{ fontSize: 24, fontWeight: 800, letterSpacing: -0.5, color: fg, fontFamily: mono }}>${value.toFixed(2)}M</div>
                        </div>
                      );
                    })}
                  </div>
                  <div style={{ fontSize: 12.5, lineHeight: 1.6, color: ink }}>
                    {exposure.industry_label} industry average <strong>${exposure.industry_average_cost_usd_millions.toFixed(2)}M</strong>{' '}
                    <span style={{ color: muted }}>(was ${exposure.industry_average_cost_prior_year_usd_millions.toFixed(2)}M last year).</span>
                    <span style={{ color: muted }}> {exposure.risk_adjustment_note}</span>
                  </div>
                  <div style={{ fontSize: 12, color: muted, marginTop: 4 }}>{exposure.exposure_range.note}</div>
                  {exposure.vendor_factors && (() => {
                    const vf = exposure.vendor_factors;
                    const shown = vf.factors.filter(f => f.status === 'applied' || f.status === 'contradicted_by_scan' || f.status === 'disputed');
                    const usd = (n: number) => `${n < 0 ? '−' : '+'}$${Math.round(Math.abs(n) / 1000)}K`;
                    const sourceText = (s: string) => s === 'both' ? 'Questionnaire + scan' : s === 'scan' ? 'Scan' : 'Questionnaire';
                    const why = (f: typeof vf.factors[number]) => f.evidence.map(e => e.finding
                      ? `Scan: ${e.finding} (${e.severity})`
                      : `“${e.question}” → ${e.answer}`).join('\n');
                    return (
                      <div style={{ marginTop: 14, paddingTop: 12, borderTop: `1px solid ${isDark ? '#1f1f1f' : T.bdr}` }}>
                        <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap', marginBottom: 8 }}>
                          <span style={{ fontSize: 10, color: muted, letterSpacing: '.06em', textTransform: 'uppercase' }}>What this vendor's answers and scan changed</span>
                          {shown.length > 0 && <span style={{ fontSize: 11.5, color: muted }}>{vf.note}</span>}
                        </div>
                        {shown.length === 0 ? (
                          <div style={{ fontSize: 12, color: muted }}>
                            {vf.has_questionnaire ? 'Nothing in its answers or scan ties to a measured cost factor yet.'
                              : 'Send a questionnaire to sharpen this estimate: answers about MFA, encryption, training, testing and access reviews each move it.'}
                          </div>
                        ) : (
                          <div style={{ display: 'grid', gap: 2 }}>
                            {shown.map(f => {
                              const counted = f.status === 'applied';
                              const tone: ToneName = !counted ? 'slate' : f.ibm_usd < 0 ? 'green' : 'red';
                              return (
                                <div key={f.key} title={why(f)} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '5px 0', fontSize: 12.5, color: ink }}>
                                  <Tone name={tone} isDark={isDark}>{usd(f.ibm_usd)}</Tone>
                                  <span style={{ flex: 1, minWidth: 0, textDecoration: counted ? 'none' : 'line-through', color: counted ? ink : muted }}>{f.label}</span>
                                  <span style={{ fontSize: 11, color: muted, whiteSpace: 'nowrap' }}>
                                    {f.status === 'contradicted_by_scan' ? 'Claimed, but the scan disagrees — not counted'
                                      : f.status === 'disputed' ? 'Claimed, but its evidence contradicts it — not counted'
                                      : sourceText(f.source)}
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        )}
                        <div style={{ fontSize: 10.5, color: muted, marginTop: 6 }}>
                          Dollar effects are IBM's measured averages (Cost of a Data Breach 2026, Figure 33), scaled to this industry. Hover a row to see the answer or finding behind it.
                        </div>
                      </div>
                    );
                  })()}
                  {exposure.records_bucket_label && (
                    <div style={{ fontSize: 12, color: muted, marginTop: 4 }}>
                      Declared record volume: {exposure.records_bucket_label}.{exposure.records_bucket_note ? ` ${exposure.records_bucket_note}` : ''}
                    </div>
                  )}
                  {dbir && (
                    <div style={{ marginTop: 10, padding: '9px 12px', borderRadius: 6, background: toneOf('blue', isDark)[0], fontSize: 11.5, color: ink }}>
                      <strong>{dbir.naics_label}</strong> saw {dbir.incidents.toLocaleString()} incidents ({dbir.confirmed_breaches.toLocaleString()} confirmed breaches) in the 2026 DBIR.
                      {' '}{dbir.top_patterns}.
                      {dbir.third_party_pct != null && ` ${dbir.third_party_pct}% involved a third party.`}
                      {dbir.vulnerability_exploitation_pct != null && ` ${dbir.vulnerability_exploitation_pct}% started with exploited vulnerabilities.`}
                      {dbir.note && <div style={{ marginTop: 4, color: muted }}>{dbir.note}</div>}
                    </div>
                  )}
                  <div style={{ fontSize: 10.5, color: muted, lineHeight: 1.5, marginTop: 10 }}>
                    {exposure.disclaimer} Sources: {exposure.sources.map(s => `${s.name} (${s.publisher})`).join(' · ')}.
                  </div>
                </div>
              );
            })()}

            {/* ── 7 Scan comparison (collapsible) ── */}
            <div id="ov-comparison" style={{ scrollMarginTop: 80 }}>
              {!comparisonOpen ? (
                <div style={{ ...card(isDark), display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={sectionTitle(isDark)}>Scan comparison</span>
                  <button style={{ ...linkBtn(isDark), marginLeft: 'auto' }} onClick={() => setComparisonOpen(true)}>Expand ▾</button>
                </div>
              ) : (<>
            {(() => {
              const muted = isDark ? '#94a3b8' : T.muted;
              const ink = isDark ? '#e2e8f0' : T.ink;
              const line = isDark ? '#1f1f1f' : T.bdr;
              const tile = isDark ? '#1a1a1a' : T.surface2;
              const good = isDark ? '#22C55E' : T.grn;
              const bad = isDark ? '#F87171' : T.red;
              const accent = isDark ? '#3B82F6' : T.blue;
              const c = comparison;
              const num = (n: number) => (Number.isInteger(n) ? String(n) : n.toFixed(1));
              const signed = (n: number) => `${n > 0 ? '+' : ''}${num(n)}`;
              const scanLabel = (scan: ComparisonScan) =>
                `${new Date(scan.date).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })} · ${scan.score}`;
              const selectStyle: React.CSSProperties = {
                fontSize: 11, border: `1px solid ${line}`, borderRadius: 4, padding: '4px 8px', maxWidth: 210,
                color: isDark ? '#94a3b8' : T.slate, background: isDark ? '#0d0d0d' : T.surface, fontFamily: sans,
              };
              const tileStyle: React.CSSProperties = { background: tile, borderRadius: 6, padding: '12px 14px' };
              const deltaPill = (text: string, color: string) => (
                <span style={{ fontSize: 11, fontWeight: 600, fontFamily: mono, padding: '1px 7px', borderRadius: 99, color, border: `1px solid ${color}55` }}>{text}</span>
              );

              if (!c || !c.has_comparison) {
                return (
                  <div style={card(isDark)}>
                    <div style={sectionHdr}><span style={sectionTitle(isDark)}>Scan comparison</span></div>
                    <div style={{ textAlign: 'center', padding: '24px 0', color: muted, fontSize: 12 }}>
                      {loadingComparison ? 'Loading comparison…' : (isSelf ? 'Run at least two scans to compare them.' : 'Run at least two scans of this vendor to compare them.')}
                    </div>
                  </div>
                );
              }

              // score trend
              const trend = c.trend;
              const scores = trend.map(point => point.score ?? 0);
              const lo = Math.max(0, Math.min(...scores) - 3);
              const hi = Math.min(100, Math.max(...scores) + 3);
              const W = 300, H = 88, padX = 22, top = 18, bottom = 24;
              const px = (i: number) => (trend.length === 1 ? W / 2 : padX + (i * (W - 2 * padX)) / (trend.length - 1));
              const py = (v: number) => top + ((hi - v) * (H - top - bottom)) / Math.max(hi - lo, 1);

              return (
                <div style={{ ...card(isDark), opacity: loadingComparison ? 0.6 : 1, transition: 'opacity .15s' }}>
                  <div style={sectionHdr}>
                    <span style={sectionTitle(isDark)}>Scan comparison</span>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                      <select value={c.base_scan.id} aria-label="Baseline scan" disabled={loadingComparison} style={selectStyle}
                        onChange={e => fetchScanComparison(e.target.value, c.head_scan.id)}>
                        {c.scans.map(scan => <option key={scan.id} value={scan.id} disabled={scan.id === c.head_scan.id}>{scanLabel(scan)}</option>)}
                      </select>
                      <span style={{ color: muted, fontSize: 12 }}>→</span>
                      <select value={c.head_scan.id} aria-label="Scan to compare" disabled={loadingComparison} style={selectStyle}
                        onChange={e => fetchScanComparison(c.base_scan.id, e.target.value)}>
                        {c.scans.map(scan => <option key={scan.id} value={scan.id} disabled={scan.id === c.base_scan.id}>{scanLabel(scan)}</option>)}
                      </select>
                      <button style={{ ...linkBtn(isDark), fontSize: 11.5 }} onClick={() => setComparisonOpen(false)}>Collapse ▴</button>
                    </div>
                  </div>

                  {/* score + trend */}
                  <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1fr) minmax(0,1.3fr)', gap: 12, marginBottom: 12 }}>
                    <div style={tileStyle}>
                      <div style={cardLabel(isDark)}>Risk score</div>
                      <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, flexWrap: 'wrap' }}>
                        <span style={{ fontSize: 15, color: muted, fontFamily: mono }}>{c.base_scan.score}</span>
                        <span style={{ color: muted }}>→</span>
                        <span style={{ fontSize: 32, fontWeight: 700, lineHeight: 1, color: scoreColor(c.head_scan.score), fontFamily: mono }}>{c.head_scan.score}</span>
                        {c.score_change === 0
                          ? <span style={{ fontSize: 11, color: muted }}>no change</span>
                          : deltaPill(signed(c.score_change), c.score_change > 0 ? good : bad)}
                      </div>
                      <div style={{ fontSize: 12, color: muted, marginTop: 8, lineHeight: 1.5 }}>
                        {c.base_scan.risk_level === c.head_scan.risk_level
                          ? `Risk level ${c.head_scan.risk_level} on both scans.`
                          : `Risk level ${c.base_scan.risk_level} → ${c.head_scan.risk_level}.`}
                        {' '}Indicators {c.indicator_total.from} → {c.indicator_total.to}.
                      </div>
                      <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
                        <button style={{ ...linkBtn(isDark), fontSize: 11 }} onClick={() => handleViewScan(c.base_scan.id)}>Open baseline scan</button>
                        <button style={{ ...linkBtn(isDark), fontSize: 11 }} onClick={() => handleViewScan(c.head_scan.id)}>Open latest scan</button>
                      </div>
                    </div>

                    <div style={tileStyle}>
                      <div style={cardLabel(isDark)}>Score across the last {trend.length} scans</div>
                      <svg viewBox={`0 0 ${W} ${H}`} width="100%" height={H} role="img" aria-label={`Score trend: ${scores.join(', ')}`} style={{ display: 'block' }}>
                        {trend.length > 1 && (
                          <polyline points={trend.map((point, i) => `${px(i)},${py(point.score ?? 0)}`).join(' ')} fill="none" stroke={accent} strokeWidth={1.5} />
                        )}
                        {trend.map((point, i) => {
                          const isHead = point.id === c.head_scan.id;
                          const isBase = point.id === c.base_scan.id;
                          const f = fmtDate(point.date);
                          return (
                            <g key={point.id}>
                              <circle cx={px(i)} cy={py(point.score ?? 0)} r={isHead ? 5 : isBase ? 4.5 : 3}
                                fill={isBase ? (isDark ? '#0d0d0d' : T.surface) : accent} stroke={accent} strokeWidth={isBase ? 2 : 0}>
                                <title>{`${f.date}, ${f.time}: ${point.score}`}</title>
                              </circle>
                              <text x={px(i)} y={py(point.score ?? 0) - 9} textAnchor="middle" fontSize={10} fill={isHead || isBase ? ink : muted} fontFamily={mono}>{point.score}</text>
                            </g>
                          );
                        })}
                        <text x={px(0)} y={H - 6} textAnchor="start" fontSize={10} fill={muted}>{fmtShort(trend[0].date).replace(/, \d{4}$/, '')}</text>
                        {trend.length > 1 && (
                          <text x={px(trend.length - 1)} y={H - 6} textAnchor="end" fontSize={10} fill={muted}>{fmtShort(trend[trend.length - 1].date).replace(/, \d{4}$/, '')}</text>
                        )}
                      </svg>
                      <div style={{ fontSize: 10, color: muted, marginTop: 2 }}>Filled dot: scan on the right of the comparison. Ringed dot: baseline.</div>
                    </div>
                  </div>
                </div>
              );
            })()}
              </>)}
            </div>

          </>
        )}

        {/* ── History Tab ── */}
        {activeTab === 'history' && vendorId && (
          <VendorHistory vendorId={vendorId} vendorName={vendor.name} isDark={isDark} />
        )}

        {activeTab === 'domains' && vendorId && vendor?.domain && (
          <VendorDomains vendorId={vendorId} vendorDomain={vendor.domain} isDark={isDark} />
        )}

        {activeTab === 'access' && vendorId && (
          <VendorAccess vendorId={vendorId} vendorName={vendor.name} isDark={isDark} />
        )}

        {activeTab === 'contacts' && vendorId && (
          <VendorContacts vendorId={vendorId} vendorName={vendor.name} isDark={isDark}
            onOpenQuestionnaires={() => setActiveTab('questionnaires')} onOpenRemediation={id => openRemediationRequest(id)} />
        )}

        {activeTab === 'fourth-parties' && vendorId && (
          <VendorFourthParties vendorId={vendorId} vendorName={vendor.name} isDark={isDark} />
        )}

        {activeTab === 'ip-addresses' && vendorId && (
          <VendorIPAddresses vendorId={vendorId} isDark={isDark} />
        )}

        {activeTab === 'security-profile' && vendorId && (
          <VendorSecurityProfile vendorId={vendorId} isDark={isDark} onOpenTab={t => setActiveTab(t as any)} />
        )}

        {activeTab === 'questionnaires' && vendorId && (
          <VendorQuestionnaires vendorId={vendorId} isDark={isDark} />
        )}

        {activeTab === 'profile' && vendorId && (
          <VendorProfile vendorId={vendorId} vendorName={vendor.name} vendorDomain={vendor.domain} isDark={isDark} riskLevel={vendor.riskLevel} onOpenTab={setActiveTab} />
        )}

        {activeTab === 'schedule' && vendorId && (
          <VendorSchedulePage vendorId={vendorId} vendor={{ name: vendor.name, domain: vendor.domain, riskLevel: vendor.riskLevel, score: vendor.score }} isDark={isDark} />
        )}

        {activeTab === 'documents' && vendorId && (
          <VendorDocuments vendorId={vendorId} isDark={isDark} />
        )}

        {activeTab === 'issues' && vendorId && (
          <VendorIssues vendorId={vendorId} vendorName={vendor.name} vendorDomain={vendor.domain} isDark={isDark}
            onOpenRemediation={openRemediationRequest} />
        )}

        {activeTab === 'contracts' && vendorId && (
          <VendorContracts vendorId={vendorId} vendorName={vendor.name} isDark={isDark} />
        )}

        {activeTab === 'assessments' && vendorId && (
          <VendorAssessments vendorId={vendorId} vendorName={vendor.name} isDark={isDark} onOpenTab={setActiveTab} onNewScan={handleNewScan} />
        )}

        {activeTab === 'remediation' && vendorId && (
          <VendorRemediation vendorId={vendorId} vendorName={vendor.name} vendorDomain={vendor.domain} isDark={isDark}
            onOpenIssues={() => setActiveTab('issues')} requestId={remediationRequestId} onRequestChange={openRemediationRequest} />
        )}
      </div>
      </div>

      {/* ── Footer ──────────────────────────────────────────────── */}
      <div style={{ padding: '12px 20px', borderTop: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, background: isDark ? '#0d0d0d' : T.surface, display: 'flex', justifyContent: 'flex-end', gap: 8, flexShrink: 0 }}>
        {!isSelf && <button onClick={() => navigate('/vendors')} style={topBtn(false, isDark)}>← Back to Vendors</button>}
        {scanError && <span style={{ alignSelf: 'center', marginRight: 'auto', fontSize: 12.5, color: '#B91C1C' }}>{scanError}</span>}
        {canScan && <ScanTypeButton label={vendor.lastScan ? '⟳ Rescan' : '⊕ Scan now'} onPick={handleNewScan} busy={vendorScan.isPending} isDark={isDark} buttonStyle={topBtn(true, isDark)} placement="top" />}
      </div>
    </div>
  );
}

/* ─── Header Export + ⋮ menus ─────────────────────────────────────────────────────────────────────── */
function VendorHeaderMenus({ vendor, isDark, role, onOpenTab }: {
  vendor: Vendor; isDark: boolean; role?: string; onOpenTab: (tab: VendorTab) => void;
}) {
  const navigate = useNavigate();
  const [open, setOpen] = useState<'export' | 'more' | null>(null);
  const [confirmArchive, setConfirmArchive] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);
  const ref = React.useRef<HTMLDivElement>(null);
  const canEdit = !!role && role !== 'viewer';
  const isAdmin = role === 'admin';
  const inactive = (vendor.status || 'active').toLowerCase() === 'cold';

  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) setOpen(null); };
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(null); };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('mousedown', onDown); document.removeEventListener('keydown', onKey); };
  }, [open]);
  useEffect(() => { if (!msg) return; const t = setTimeout(() => setMsg(null), 2500); return () => clearTimeout(t); }, [msg]);

  const statusMutation = useMutation({
    mutationFn: () => api.put(`/v1/vendors/${vendor.id}`, { name: vendor.name, domain: vendor.domain, status: inactive ? 'active' : 'cold' }),
    meta: { invalidates: [['vendors']] },
    onSuccess: () => setMsg(inactive ? 'Marked as active' : 'Marked as inactive'),
    onError: () => setMsg('Could not change the status'),
  });
  const archiveMutation = useMutation({
    mutationFn: () => api.delete(`/v1/vendors/${vendor.id}`, { params: { permanent: false } }),
    meta: { invalidates: [['vendors']] },
    onSuccess: () => navigate('/vendors'),
    onError: () => { setConfirmArchive(false); setMsg('Could not archive the vendor'); },
  });

  const line = isDark ? '#1f1f1f' : T.bdr;
  const ink = isDark ? '#e2e8f0' : T.ink;
  const sub = isDark ? '#94a3b8' : T.muted;
  const menu: React.CSSProperties = {
    position: 'absolute', top: 'calc(100% + 6px)', right: 0, zIndex: 50, minWidth: 260, padding: 6,
    background: isDark ? '#0d0d0d' : '#fff', border: `1px solid ${line}`, borderRadius: 10,
    boxShadow: isDark ? '0 10px 30px rgba(0,0,0,.6)' : '0 10px 30px rgba(15,23,42,.12)',
  };
  const itemStyle = (danger?: boolean): React.CSSProperties => ({
    display: 'block', width: '100%', textAlign: 'left', padding: '8px 10px', border: 'none', borderRadius: 6,
    background: 'transparent', cursor: 'pointer', fontFamily: sans, fontSize: 12.5, fontWeight: 500,
    color: danger ? '#DC2626' : ink,
  });
  const item = (label: string, onClick: () => void, hint?: string, danger?: boolean) => (
    <button key={label} role="menuitem" style={itemStyle(danger)}
      onMouseEnter={e => { e.currentTarget.style.background = isDark ? '#1a1a1a' : '#F1F5F9'; }}
      onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
      onClick={() => { setOpen(null); onClick(); }}>
      {label}
      {hint && <div style={{ fontSize: 11, fontWeight: 400, color: sub, marginTop: 2 }}>{hint}</div>}
    </button>
  );
  const divider = <div style={{ height: 1, background: line, margin: '4px 2px' }} />;
  const report = (template: string) => navigate(`/reports?template=${template}&vendor=${vendor.id}`);
  const copyLink = () => {
    const url = `${window.location.origin}/vendors/${vendor.id}`;
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(() => setMsg('Link copied'), () => setMsg('Could not copy the link'));
    else setMsg('Could not copy the link');
  };

  return (
    <div ref={ref} style={{ display: 'flex', gap: 6 }}>
      <div style={{ position: 'relative' }}>
        <button style={topBtn(false, isDark)} aria-haspopup="menu" aria-expanded={open === 'export'}
          onClick={() => setOpen(open === 'export' ? null : 'export')}>↓ Export</button>
        {open === 'export' && (
          <div role="menu" style={menu}>
            {item('Security report (PDF)', () => report('vendor-full'), 'Every risk with its fix, history and remediation')}
            {item('Vendor summary (PDF)', () => report('vendor-brief'), 'A 4-page summary for leadership')}
            {item('Findings register (CSV)', () => report('findings-csv'), 'Every open finding, one row each')}
          </div>
        )}
      </div>
      <div style={{ position: 'relative' }}>
        <button style={{ ...topBtn(false, isDark), padding: '7px 10px', color: sub }} aria-label="More actions" aria-haspopup="menu"
          aria-expanded={open === 'more'} onClick={() => setOpen(open === 'more' ? null : 'more')}>⋮</button>
        {open === 'more' && (
          <div role="menu" style={menu}>
            {canEdit && item('Edit profile', () => { onOpenTab('profile'); setTimeout(() => document.getElementById('vp-record')?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 600); })}
            {item('Compare with other vendors', () => navigate(`/reports/comparison?vendors=${vendor.id}`))}
            {item('Copy link to this vendor', copyLink)}
            {item('Visit website ↗', () => window.open(`https://${vendor.domain}`, '_blank', 'noopener'))}
            {(canEdit || isAdmin) && divider}
            {canEdit && item(inactive ? 'Mark as active' : 'Mark as inactive', () => statusMutation.mutate(),
              inactive ? 'Back in scans, alerts and dashboards' : 'Stops scheduled scans, kept out of dashboards')}
            {isAdmin && item('Archive vendor', () => setConfirmArchive(true), 'Hidden from your portfolio, restorable later', true)}
          </div>
        )}
      </div>

      {msg && (
        <div style={{ position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)', zIndex: 1700, padding: '9px 16px', borderRadius: 8,
          background: isDark ? '#e2e8f0' : '#0F172A', color: isDark ? '#0F172A' : '#fff', fontFamily: sans, fontSize: 12.5, fontWeight: 500 }}>{msg}</div>
      )}

      {confirmArchive && (
        <div onMouseDown={() => { if (!archiveMutation.isPending) setConfirmArchive(false); }}
          style={{ position: 'fixed', inset: 0, zIndex: 1650, background: 'rgba(15,23,42,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div onMouseDown={e => e.stopPropagation()} style={{ width: 'min(420px, 100%)', background: isDark ? '#0d0d0d' : '#fff', border: `1px solid ${line}`, borderRadius: 12, padding: 20, fontFamily: sans }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: ink, marginBottom: 6 }}>Archive {vendor.name}?</div>
            <div style={{ fontSize: 12.5, color: sub, lineHeight: 1.5, marginBottom: 18 }}>
              The vendor is hidden from your portfolio and stops being scanned. You can restore it from the Archived view on the Vendors page.
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <button style={topBtn(false, isDark)} disabled={archiveMutation.isPending} onClick={() => setConfirmArchive(false)}>Cancel</button>
              <button style={{ ...topBtn(true, isDark), background: '#DC2626', borderColor: '#DC2626' }} disabled={archiveMutation.isPending}
                onClick={() => archiveMutation.mutate()}>{archiveMutation.isPending ? 'Archiving…' : 'Archive'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
